/* tslint:disable */
/* eslint-disable */
/**
 * COSMEbi API
 * COSMEbi API
 *
 * The version of the OpenAPI document: 1.0.1
 * Contact: developers@alleeks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Ad
 */
export interface Ad {
    /**
     * 
     * @type {number}
     * @memberof Ad
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    'name'?: string;
    /**
     * 
     * @type {AdType}
     * @memberof Ad
     */
    'adType': AdType;
    /**
     * 
     * @type {boolean}
     * @memberof Ad
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    'pcImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    'spImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    'linkUrl': string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    'publishFrom': string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    'publishTill': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AdType = {
    Top: 'TOP',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    Banner: 'BANNER',
    AppOnboarding: 'APP_ONBOARDING'
} as const;

export type AdType = typeof AdType[keyof typeof AdType];


/**
 * レビュー解析
 * @export
 * @interface AnalysisProductReviewsRequest
 */
export interface AnalysisProductReviewsRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalysisProductReviewsRequest
     */
    'type': AnalysisProductReviewsRequestTypeEnum;
    /**
     * 
     * @type {AnalysisProductReviewsRequestData}
     * @memberof AnalysisProductReviewsRequest
     */
    'data': AnalysisProductReviewsRequestData;
}

export const AnalysisProductReviewsRequestTypeEnum = {
    AnalysisProductReviews: 'AnalysisProductReviews'
} as const;

export type AnalysisProductReviewsRequestTypeEnum = typeof AnalysisProductReviewsRequestTypeEnum[keyof typeof AnalysisProductReviewsRequestTypeEnum];

/**
 * 
 * @export
 * @interface AnalysisProductReviewsRequestData
 */
export interface AnalysisProductReviewsRequestData {
    /**
     * 
     * @type {AnalysisProductReviewsSubject}
     * @memberof AnalysisProductReviewsRequestData
     */
    'subject': AnalysisProductReviewsSubject;
    /**
     * 
     * @type {Array<UserContentStatus>}
     * @memberof AnalysisProductReviewsRequestData
     */
    'statuses'?: Array<UserContentStatus>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnalysisProductReviewsRequestData
     */
    'channels'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AnalysisProductReviewsRequestData
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalysisProductReviewsRequestData
     */
    'productName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnalysisProductReviewsRequestData
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalysisProductReviewsRequestData
     */
    'releaseDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisProductReviewsRequestData
     */
    'releaseDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisProductReviewsRequestData
     */
    'applyDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisProductReviewsRequestData
     */
    'applyDateTill'?: string;
}
/**
 * レビュー解析
 * @export
 * @interface AnalysisProductReviewsResponse
 */
export interface AnalysisProductReviewsResponse {
    /**
     * 
     * @type {string}
     * @memberof AnalysisProductReviewsResponse
     */
    'type': AnalysisProductReviewsResponseTypeEnum;
    /**
     * 
     * @type {AnalysisProductReviewsResponseData}
     * @memberof AnalysisProductReviewsResponse
     */
    'data': AnalysisProductReviewsResponseData;
}

export const AnalysisProductReviewsResponseTypeEnum = {
    AnalysisProductReviews: 'AnalysisProductReviews'
} as const;

export type AnalysisProductReviewsResponseTypeEnum = typeof AnalysisProductReviewsResponseTypeEnum[keyof typeof AnalysisProductReviewsResponseTypeEnum];

/**
 * 
 * @export
 * @interface AnalysisProductReviewsResponseData
 */
export interface AnalysisProductReviewsResponseData {
    /**
     * 
     * @type {Array<Product & AnalysisResponse>}
     * @memberof AnalysisProductReviewsResponseData
     */
    'products': Array<Product & AnalysisResponse>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AnalysisProductReviewsSubject = {
    Review: 'review',
    Favorite: 'favorite'
} as const;

export type AnalysisProductReviewsSubject = typeof AnalysisProductReviewsSubject[keyof typeof AnalysisProductReviewsSubject];


/**
 * 
 * @export
 * @interface AnalysisResponse
 */
export interface AnalysisResponse {
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'ranking': number;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'reviewCount': number;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'favoriteCount': number;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'reviewAverage': number;
}
/**
 * @type AuthorizedRequest
 * @export
 */
export type AuthorizedRequest = AnalysisProductReviewsRequest | CreateAdRequest | CreateBrandRequest | CreateCategoryRequest | CreateCsvLogsRequest | CreateCustomerRequest | CreateGlobalNotificationRequest | CreateMagazineTemplateRequest | CreateMakerRequest | CreateManagerRequest | CreateProductRecommendRequest | CreateProductRequest | CreateTagRequest | DestroyAdRequest | DestroyBrandRequest | DestroyCategoryRequest | DestroyCustomerRequest | DestroyGlobalNotificationRequest | DestroyMagazineTemplateRequest | DestroyMakerRequest | DestroyManagerRequest | DestroyProductRecommendRequest | DestroyProductReviewRequest | DestroyQaAnswerRequest | DestroyQaRequest | DestroyReportRequest | DestroyTagRequest | IndexAdsRequest | IndexBrandsRequest | IndexCategoriesRequest | IndexChanelsRequest | IndexCustomersRequest | IndexGlobalNotificationsRequest | IndexInterestsRequest | IndexKodawarisRequest | IndexMailMagazineCustomersRequest | IndexMailMagazineHistoriesRequest | IndexMailMagazineTemplatesRequest | IndexMakersRequest | IndexManagersRequest | IndexPrefsRequest | IndexPresentCampaignsRequest | IndexPresentHistoriesRequest | IndexProductRecommendsRequest | IndexProductReviewsRequest | IndexProductsRequest | IndexQaAnswersRequest | IndexQasRequest | IndexReportThemesRequest | IndexReportsRequest | IndexSkinsRequest | IndexTagsRequest | ResendProvisionalRegistrationEmailRequest | SendMailMagazineRequest | ShowAdRequest | ShowBrandRequest | ShowCustomerRequest | ShowManagerRequest | ShowMeRequest | ShowProductRequest | ShowProductReviewRequest | ShowQaAnswerRequest | ShowQaRequest | ShowReportRequest | UpdateAdRequest | UpdateBrandRequest | UpdateCategoryRequest | UpdateCustomerRequest | UpdateGlobalNotificationRequest | UpdateMagazineTemplateRequest | UpdateMakerRequest | UpdateManagerRequest | UpdateProductRecommendRequest | UpdateProductRequest | UpdateProductReviewRequest | UpdateQaAnswerRequest | UpdateQaRequest | UpdateReportRequest | UpdateTagRequest;

/**
 * @type AuthorizedResponse
 * @export
 */
export type AuthorizedResponse = AnalysisProductReviewsResponse | CreateAdResponse | CreateBrandResponse | CreateCategoryResponse | CreateCsvLogsResponse | CreateCustomerResponse | CreateGlobalNotificationResponse | CreateMagazineTemplateResponse | CreateMakerResponse | CreateManagerResponse | CreateProductRecommendResponse | CreateProductResponse | CreateTagResponse | DestroyAdResponse | DestroyBrandResponse | DestroyCategoryResponse | DestroyCustomerResponse | DestroyGlobalNotificationResponse | DestroyMagazineTemplateResponse | DestroyMakerResponse | DestroyManagerResponse | DestroyProductRecommendResponse | DestroyProductReviewResponse | DestroyQaAnswerResponse | DestroyQaResponse | DestroyReportResponse | DestroyTagResponse | IndexAdsResponse | IndexBrandsResponse | IndexCategoriesResponse | IndexChanelsResponse | IndexCustomersResponse | IndexGlobalNotificationsResponse | IndexInterestsResponse | IndexKodawarisResponse | IndexMailMagazineCustomersResponse | IndexMailMagazineHistoriesResponse | IndexMailMagazineTemplatesResponse | IndexMakersResponse | IndexManagersResponse | IndexPrefsResponse | IndexPresentCampaignsResponse | IndexPresentHistoriesResponse | IndexProductRecommendsResponse | IndexProductReviewsResponse | IndexProductsResponse | IndexQaAnswersResponse | IndexQasResponse | IndexReportThemesResponse | IndexReportsResponse | IndexSkinsResponse | IndexTagsResponse | ResendProvisionalRegistrationEmailCustomerResponse | SendMailMagazineResponse | ShowAdResponse | ShowBrandResponse | ShowCustomerResponse | ShowManagerResponse | ShowMeResponse | ShowProductResponse | ShowProductReviewResponse | ShowQaAnswerResponse | ShowQaResponse | ShowReportResponse | UpdateAdResponse | UpdateBrandResponse | UpdateCategoryResponse | UpdateCustomerResponse | UpdateGlobalNotificationResponse | UpdateMagazineTemplateResponse | UpdateMakerResponse | UpdateManagerResponse | UpdateProductRecommendResponse | UpdateProductResponse | UpdateProductReviewResponse | UpdateQaAnswerResponse | UpdateQaResponse | UpdateReportResponse | UpdateTagResponse;

/**
 * 
 * @export
 * @interface Brand
 */
export interface Brand {
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'akasatana': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'channel': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'subName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'searchWord'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'purchaseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'topPageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'isPublished': boolean;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'sortNo'?: number;
    /**
     * 
     * @type {Maker}
     * @memberof Brand
     */
    'maker': Maker;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'hierarchy': number;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'sortNo': number;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'parentCategoryId'?: number;
    /**
     * 
     * @type {Category}
     * @memberof Category
     */
    'parentCategory'?: Category;
    /**
     * 
     * @type {Manager}
     * @memberof Category
     */
    'creator'?: Manager;
}
/**
 * 
 * @export
 * @interface Chanel
 */
export interface Chanel {
    /**
     * 
     * @type {number}
     * @memberof Chanel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Chanel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Chanel
     */
    'sortNo'?: number;
}
/**
 * 
 * @export
 * @interface Clinic
 */
export interface Clinic {
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'id': number;
    /**
     * 
     * @type {UserContentStatus}
     * @memberof Clinic
     */
    'statusId': UserContentStatus;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'clinicName': string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'image1Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'image2Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'image3Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'image4Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'image5Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'image6Url'?: string;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product1'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product2'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product3'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product4'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product5'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product6'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product7'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'product8'?: number;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'youtube'?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinic
     */
    'applyDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'customerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Clinic
     */
    'themeId'?: number;
    /**
     * 
     * @type {Customer}
     * @memberof Clinic
     */
    'customer'?: Customer;
    /**
     * 
     * @type {ClinicTheme}
     * @memberof Clinic
     */
    'theme'?: ClinicTheme;
}
/**
 * 
 * @export
 * @interface ClinicTheme
 */
export interface ClinicTheme {
    /**
     * 
     * @type {number}
     * @memberof ClinicTheme
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClinicTheme
     */
    'name'?: string;
}
/**
 * 広告作成
 * @export
 * @interface CreateAdRequest
 */
export interface CreateAdRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAdRequest
     */
    'type': CreateAdRequestTypeEnum;
    /**
     * 
     * @type {CreateAdRequestData}
     * @memberof CreateAdRequest
     */
    'data': CreateAdRequestData;
}

export const CreateAdRequestTypeEnum = {
    CreateAd: 'CreateAd'
} as const;

export type CreateAdRequestTypeEnum = typeof CreateAdRequestTypeEnum[keyof typeof CreateAdRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateAdRequestData
 */
export interface CreateAdRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateAdRequestData
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAdRequestData
     */
    'enabled': boolean;
    /**
     * 
     * @type {AdType}
     * @memberof CreateAdRequestData
     */
    'adType': AdType;
    /**
     * 
     * @type {string}
     * @memberof CreateAdRequestData
     */
    'pcImage': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdRequestData
     */
    'spImage': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdRequestData
     */
    'linkUrl': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdRequestData
     */
    'publishFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdRequestData
     */
    'publishTill'?: string;
}
/**
 * 広告作成
 * @export
 * @interface CreateAdResponse
 */
export interface CreateAdResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponse
     */
    'type': CreateAdResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateAdResponse
     */
    'data': CreateAdResponseData;
}

export const CreateAdResponseTypeEnum = {
    CreateAd: 'CreateAd'
} as const;

export type CreateAdResponseTypeEnum = typeof CreateAdResponseTypeEnum[keyof typeof CreateAdResponseTypeEnum];

/**
 * 
 * @export
 * @interface CreateAdResponseData
 */
export interface CreateAdResponseData {
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseData
     */
    'message': string;
}
/**
 * ブランド作成
 * @export
 * @interface CreateBrandRequest
 */
export interface CreateBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'type': CreateBrandRequestTypeEnum;
    /**
     * 
     * @type {CreateBrandRequestData}
     * @memberof CreateBrandRequest
     */
    'data': CreateBrandRequestData;
}

export const CreateBrandRequestTypeEnum = {
    CreateBrand: 'CreateBrand'
} as const;

export type CreateBrandRequestTypeEnum = typeof CreateBrandRequestTypeEnum[keyof typeof CreateBrandRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateBrandRequestData
 */
export interface CreateBrandRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequestData
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequestData
     */
    'subName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequestData
     */
    'akasatana': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequestData
     */
    'channel': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequestData
     */
    'searchWord'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequestData
     */
    'purchaseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequestData
     */
    'topPageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBrandRequestData
     */
    'isPublished': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateBrandRequestData
     */
    'makerId': number;
}
/**
 * ブランド作成
 * @export
 * @interface CreateBrandResponse
 */
export interface CreateBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateBrandResponse
     */
    'type': CreateBrandResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateBrandResponse
     */
    'data': CreateAdResponseData;
}

export const CreateBrandResponseTypeEnum = {
    CreateBrand: 'CreateBrand'
} as const;

export type CreateBrandResponseTypeEnum = typeof CreateBrandResponseTypeEnum[keyof typeof CreateBrandResponseTypeEnum];

/**
 * カテゴリー作成
 * @export
 * @interface CreateCategoryRequest
 */
export interface CreateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    'type': CreateCategoryRequestTypeEnum;
    /**
     * 
     * @type {CreateCategoryRequestData}
     * @memberof CreateCategoryRequest
     */
    'data': CreateCategoryRequestData;
}

export const CreateCategoryRequestTypeEnum = {
    CreateCategory: 'CreateCategory'
} as const;

export type CreateCategoryRequestTypeEnum = typeof CreateCategoryRequestTypeEnum[keyof typeof CreateCategoryRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateCategoryRequestData
 */
export interface CreateCategoryRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequestData
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCategoryRequestData
     */
    'parentCategoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCategoryRequestData
     */
    'sortNo'?: number;
}
/**
 * カテゴリー作成
 * @export
 * @interface CreateCategoryResponse
 */
export interface CreateCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryResponse
     */
    'type': CreateCategoryResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateCategoryResponse
     */
    'data': CreateAdResponseData;
}

export const CreateCategoryResponseTypeEnum = {
    CreateCategory: 'CreateCategory'
} as const;

export type CreateCategoryResponseTypeEnum = typeof CreateCategoryResponseTypeEnum[keyof typeof CreateCategoryResponseTypeEnum];

/**
 * COSMEbi管理画面CSVダウンロードログ
 * @export
 * @interface CreateCsvLogsRequest
 */
export interface CreateCsvLogsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCsvLogsRequest
     */
    'type': CreateCsvLogsRequestTypeEnum;
    /**
     * 
     * @type {CreateCsvLogsRequestData}
     * @memberof CreateCsvLogsRequest
     */
    'data': CreateCsvLogsRequestData;
}

export const CreateCsvLogsRequestTypeEnum = {
    CreateCsvLogs: 'CreateCsvLogs'
} as const;

export type CreateCsvLogsRequestTypeEnum = typeof CreateCsvLogsRequestTypeEnum[keyof typeof CreateCsvLogsRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateCsvLogsRequestData
 */
export interface CreateCsvLogsRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateCsvLogsRequestData
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCsvLogsRequestData
     */
    'actionType': string;
}
/**
 * COSMEbi管理画面CSVダウンロードログ
 * @export
 * @interface CreateCsvLogsResponse
 */
export interface CreateCsvLogsResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateCsvLogsResponse
     */
    'type': CreateCsvLogsResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateCsvLogsResponse
     */
    'data': CreateAdResponseData;
}

export const CreateCsvLogsResponseTypeEnum = {
    CreateCsvLogs: 'CreateCsvLogs'
} as const;

export type CreateCsvLogsResponseTypeEnum = typeof CreateCsvLogsResponseTypeEnum[keyof typeof CreateCsvLogsResponseTypeEnum];

/**
 * 会員作成
 * @export
 * @interface CreateCustomerRequest
 */
export interface CreateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'type': CreateCustomerRequestTypeEnum;
    /**
     * 
     * @type {CreateCustomerRequestData}
     * @memberof CreateCustomerRequest
     */
    'data': CreateCustomerRequestData;
}

export const CreateCustomerRequestTypeEnum = {
    CreateCustomer: 'CreateCustomer'
} as const;

export type CreateCustomerRequestTypeEnum = typeof CreateCustomerRequestTypeEnum[keyof typeof CreateCustomerRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateCustomerRequestData
 */
export interface CreateCustomerRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'password': string;
    /**
     * 
     * @type {CustomerStatus}
     * @memberof CreateCustomerRequestData
     */
    'customerStatusId'?: CustomerStatus;
    /**
     * 
     * @type {OfficialStatus}
     * @memberof CreateCustomerRequestData
     */
    'officialStatusId'?: OfficialStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'name01'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'name02'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'kana01'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'kana02'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'addr01'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'addr02'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'birth'?: string;
    /**
     * 
     * @type {MailMagazineFlg}
     * @memberof CreateCustomerRequestData
     */
    'plgMailmagazineFlg'?: MailMagazineFlg;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'nicname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'facebook'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'instagtam'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestData
     */
    'blog'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateCustomerRequestData
     */
    'interestIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateCustomerRequestData
     */
    'skinIds'?: Array<number>;
}
/**
 * 会員作成
 * @export
 * @interface CreateCustomerResponse
 */
export interface CreateCustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerResponse
     */
    'type': CreateCustomerResponseTypeEnum;
    /**
     * 
     * @type {CreateCustomerResponseData}
     * @memberof CreateCustomerResponse
     */
    'data': CreateCustomerResponseData;
}

export const CreateCustomerResponseTypeEnum = {
    CreateCustomer: 'CreateCustomer'
} as const;

export type CreateCustomerResponseTypeEnum = typeof CreateCustomerResponseTypeEnum[keyof typeof CreateCustomerResponseTypeEnum];

/**
 * 
 * @export
 * @interface CreateCustomerResponseData
 */
export interface CreateCustomerResponseData {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerResponseData
     */
    'type': CreateCustomerResponseDataTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateCustomerResponseData
     */
    'data': CreateAdResponseData;
}

export const CreateCustomerResponseDataTypeEnum = {
    CreateCustomer: 'CreateCustomer'
} as const;

export type CreateCustomerResponseDataTypeEnum = typeof CreateCustomerResponseDataTypeEnum[keyof typeof CreateCustomerResponseDataTypeEnum];

/**
 * 全体通知作成
 * @export
 * @interface CreateGlobalNotificationRequest
 */
export interface CreateGlobalNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalNotificationRequest
     */
    'type': CreateGlobalNotificationRequestTypeEnum;
    /**
     * 
     * @type {CreateGlobalNotificationRequestData}
     * @memberof CreateGlobalNotificationRequest
     */
    'data': CreateGlobalNotificationRequestData;
}

export const CreateGlobalNotificationRequestTypeEnum = {
    CreateGlobalNotification: 'CreateGlobalNotification'
} as const;

export type CreateGlobalNotificationRequestTypeEnum = typeof CreateGlobalNotificationRequestTypeEnum[keyof typeof CreateGlobalNotificationRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateGlobalNotificationRequestData
 */
export interface CreateGlobalNotificationRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalNotificationRequestData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalNotificationRequestData
     */
    'linkType'?: CreateGlobalNotificationRequestDataLinkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalNotificationRequestData
     */
    'linkValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalNotificationRequestData
     */
    'notifiedAt': string;
}

export const CreateGlobalNotificationRequestDataLinkTypeEnum = {
    Info: 'info'
} as const;

export type CreateGlobalNotificationRequestDataLinkTypeEnum = typeof CreateGlobalNotificationRequestDataLinkTypeEnum[keyof typeof CreateGlobalNotificationRequestDataLinkTypeEnum];

/**
 * 全体通知作成
 * @export
 * @interface CreateGlobalNotificationResponse
 */
export interface CreateGlobalNotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalNotificationResponse
     */
    'type': CreateGlobalNotificationResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateGlobalNotificationResponse
     */
    'data': CreateAdResponseData;
}

export const CreateGlobalNotificationResponseTypeEnum = {
    CreateGlobalNotification: 'CreateGlobalNotification'
} as const;

export type CreateGlobalNotificationResponseTypeEnum = typeof CreateGlobalNotificationResponseTypeEnum[keyof typeof CreateGlobalNotificationResponseTypeEnum];

/**
 * メールマガジンテンプレート作成
 * @export
 * @interface CreateMagazineTemplateRequest
 */
export interface CreateMagazineTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMagazineTemplateRequest
     */
    'type': CreateMagazineTemplateRequestTypeEnum;
    /**
     * 
     * @type {SendMailMagazineRequestData}
     * @memberof CreateMagazineTemplateRequest
     */
    'data': SendMailMagazineRequestData;
}

export const CreateMagazineTemplateRequestTypeEnum = {
    CreateMagazineTemplate: 'CreateMagazineTemplate'
} as const;

export type CreateMagazineTemplateRequestTypeEnum = typeof CreateMagazineTemplateRequestTypeEnum[keyof typeof CreateMagazineTemplateRequestTypeEnum];

/**
 * メールマガジンテンプレート作成
 * @export
 * @interface CreateMagazineTemplateResponse
 */
export interface CreateMagazineTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateMagazineTemplateResponse
     */
    'type': CreateMagazineTemplateResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateMagazineTemplateResponse
     */
    'data': CreateAdResponseData;
}

export const CreateMagazineTemplateResponseTypeEnum = {
    CreateMagazineTemplate: 'CreateMagazineTemplate'
} as const;

export type CreateMagazineTemplateResponseTypeEnum = typeof CreateMagazineTemplateResponseTypeEnum[keyof typeof CreateMagazineTemplateResponseTypeEnum];

/**
 * メーカー作成
 * @export
 * @interface CreateMakerRequest
 */
export interface CreateMakerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMakerRequest
     */
    'type': CreateMakerRequestTypeEnum;
    /**
     * 
     * @type {CreateMakerRequestData}
     * @memberof CreateMakerRequest
     */
    'data': CreateMakerRequestData;
}

export const CreateMakerRequestTypeEnum = {
    CreateMaker: 'CreateMaker'
} as const;

export type CreateMakerRequestTypeEnum = typeof CreateMakerRequestTypeEnum[keyof typeof CreateMakerRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateMakerRequestData
 */
export interface CreateMakerRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateMakerRequestData
     */
    'name': string;
}
/**
 * メーカー作成
 * @export
 * @interface CreateMakerResponse
 */
export interface CreateMakerResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateMakerResponse
     */
    'type': CreateMakerResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateMakerResponse
     */
    'data': CreateAdResponseData;
}

export const CreateMakerResponseTypeEnum = {
    CreateMaker: 'CreateMaker'
} as const;

export type CreateMakerResponseTypeEnum = typeof CreateMakerResponseTypeEnum[keyof typeof CreateMakerResponseTypeEnum];

/**
 * COSMEbi管理者作成
 * @export
 * @interface CreateManagerRequest
 */
export interface CreateManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateManagerRequest
     */
    'type': CreateManagerRequestTypeEnum;
    /**
     * 
     * @type {CreateManagerRequestData}
     * @memberof CreateManagerRequest
     */
    'data': CreateManagerRequestData;
}

export const CreateManagerRequestTypeEnum = {
    CreateManager: 'CreateManager'
} as const;

export type CreateManagerRequestTypeEnum = typeof CreateManagerRequestTypeEnum[keyof typeof CreateManagerRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateManagerRequestData
 */
export interface CreateManagerRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateManagerRequestData
     */
    'email': string;
    /**
     * 
     * @type {ManagerAuthority}
     * @memberof CreateManagerRequestData
     */
    'authority': ManagerAuthority;
    /**
     * 
     * @type {boolean}
     * @memberof CreateManagerRequestData
     */
    'personalDataFlg': boolean;
}
/**
 * COSMEbi管理者作成
 * @export
 * @interface CreateManagerResponse
 */
export interface CreateManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateManagerResponse
     */
    'type': CreateManagerResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateManagerResponse
     */
    'data': CreateAdResponseData;
}

export const CreateManagerResponseTypeEnum = {
    CreateManager: 'CreateManager'
} as const;

export type CreateManagerResponseTypeEnum = typeof CreateManagerResponseTypeEnum[keyof typeof CreateManagerResponseTypeEnum];

/**
 * おすすめ商品作成
 * @export
 * @interface CreateProductRecommendRequest
 */
export interface CreateProductRecommendRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProductRecommendRequest
     */
    'type': CreateProductRecommendRequestTypeEnum;
    /**
     * 
     * @type {CreateProductRecommendRequestData}
     * @memberof CreateProductRecommendRequest
     */
    'data': CreateProductRecommendRequestData;
}

export const CreateProductRecommendRequestTypeEnum = {
    CreateProductRecommend: 'CreateProductRecommend'
} as const;

export type CreateProductRecommendRequestTypeEnum = typeof CreateProductRecommendRequestTypeEnum[keyof typeof CreateProductRecommendRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductRecommendRequestData
 */
export interface CreateProductRecommendRequestData {
    /**
     * 
     * @type {number}
     * @memberof CreateProductRecommendRequestData
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRecommendRequestData
     */
    'applyDate': string;
}
/**
 * おすすめ商品作成
 * @export
 * @interface CreateProductRecommendResponse
 */
export interface CreateProductRecommendResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateProductRecommendResponse
     */
    'type': CreateProductRecommendResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateProductRecommendResponse
     */
    'data': CreateAdResponseData;
}

export const CreateProductRecommendResponseTypeEnum = {
    CreateProductRecommend: 'CreateProductRecommend'
} as const;

export type CreateProductRecommendResponseTypeEnum = typeof CreateProductRecommendResponseTypeEnum[keyof typeof CreateProductRecommendResponseTypeEnum];

/**
 * 商品作成
 * @export
 * @interface CreateProductRequest
 */
export interface CreateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    'type': CreateProductRequestTypeEnum;
    /**
     * 
     * @type {CreateProductRequestData}
     * @memberof CreateProductRequest
     */
    'data': CreateProductRequestData;
}

export const CreateProductRequestTypeEnum = {
    CreateProduct: 'CreateProduct'
} as const;

export type CreateProductRequestTypeEnum = typeof CreateProductRequestTypeEnum[keyof typeof CreateProductRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductRequestData
 */
export interface CreateProductRequestData {
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'name': string;
    /**
     * 
     * @type {ProductStatus}
     * @memberof CreateProductRequestData
     */
    'productStatusId'?: ProductStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'descriptionDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'productUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'productUrlTracking'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'brandUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'brandUrlTracking'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'priceText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'priceUnit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequestData
     */
    'price02': number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequestData
     */
    'brandId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'affiliate1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'affiliate2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'affiliate3'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequestData
     */
    'affiliate4'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateProductRequestData
     */
    'categoryIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateProductRequestData
     */
    'tagIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateProductRequestData
     */
    'kodawariIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequestData
     */
    'productImages'?: Array<string>;
}
/**
 * 商品作成
 * @export
 * @interface CreateProductResponse
 */
export interface CreateProductResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateProductResponse
     */
    'type': CreateProductResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateProductResponse
     */
    'data': CreateAdResponseData;
}

export const CreateProductResponseTypeEnum = {
    CreateProduct: 'CreateProduct'
} as const;

export type CreateProductResponseTypeEnum = typeof CreateProductResponseTypeEnum[keyof typeof CreateProductResponseTypeEnum];

/**
 * タグ作成
 * @export
 * @interface CreateTagRequest
 */
export interface CreateTagRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTagRequest
     */
    'type': CreateTagRequestTypeEnum;
    /**
     * 
     * @type {CreateMakerRequestData}
     * @memberof CreateTagRequest
     */
    'data': CreateMakerRequestData;
}

export const CreateTagRequestTypeEnum = {
    CreateTag: 'CreateTag'
} as const;

export type CreateTagRequestTypeEnum = typeof CreateTagRequestTypeEnum[keyof typeof CreateTagRequestTypeEnum];

/**
 * タグ作成
 * @export
 * @interface CreateTagResponse
 */
export interface CreateTagResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateTagResponse
     */
    'type': CreateTagResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof CreateTagResponse
     */
    'data': CreateAdResponseData;
}

export const CreateTagResponseTypeEnum = {
    CreateTag: 'CreateTag'
} as const;

export type CreateTagResponseTypeEnum = typeof CreateTagResponseTypeEnum[keyof typeof CreateTagResponseTypeEnum];

/**
 * 
 * @export
 * @interface Customer
 */
export interface Customer {
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'email': string;
    /**
     * 
     * @type {CustomerStatus}
     * @memberof Customer
     */
    'customerStatusId': CustomerStatus;
    /**
     * 
     * @type {OfficialStatus}
     * @memberof Customer
     */
    'officialStatusId': OfficialStatus;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'name01'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'name02'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'kana01'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'kana02'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'addr01'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'addr02'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'birth'?: string;
    /**
     * 
     * @type {MailMagazineFlg}
     * @memberof Customer
     */
    'plgMailmagazineFlg'?: MailMagazineFlg;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'nicname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'facebook'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'instagtam'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'blog'?: string;
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'reviewCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'qaCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    'clinicCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'create_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'update_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {Pref}
     * @memberof Customer
     */
    'pref'?: Pref;
    /**
     * 
     * @type {Array<Skin>}
     * @memberof Customer
     */
    'skins'?: Array<Skin>;
    /**
     * 
     * @type {Array<Interest>}
     * @memberof Customer
     */
    'interests'?: Array<Interest>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerStatus = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type CustomerStatus = typeof CustomerStatus[keyof typeof CustomerStatus];


/**
 * 広告削除
 * @export
 * @interface DestroyAdRequest
 */
export interface DestroyAdRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyAdRequest
     */
    'type': DestroyAdRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyAdRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyAdRequestTypeEnum = {
    DestroyAd: 'DestroyAd'
} as const;

export type DestroyAdRequestTypeEnum = typeof DestroyAdRequestTypeEnum[keyof typeof DestroyAdRequestTypeEnum];

/**
 * 広告削除
 * @export
 * @interface DestroyAdResponse
 */
export interface DestroyAdResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyAdResponse
     */
    'type': DestroyAdResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyAdResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyAdResponseTypeEnum = {
    DestroyAd: 'DestroyAd'
} as const;

export type DestroyAdResponseTypeEnum = typeof DestroyAdResponseTypeEnum[keyof typeof DestroyAdResponseTypeEnum];

/**
 * 
 * @export
 * @interface DestroyAdResponseData
 */
export interface DestroyAdResponseData {
    /**
     * 
     * @type {string}
     * @memberof DestroyAdResponseData
     */
    'message'?: string;
}
/**
 * ブランド削除
 * @export
 * @interface DestroyBrandRequest
 */
export interface DestroyBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyBrandRequest
     */
    'type': DestroyBrandRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyBrandRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyBrandRequestTypeEnum = {
    DestroyBrand: 'DestroyBrand'
} as const;

export type DestroyBrandRequestTypeEnum = typeof DestroyBrandRequestTypeEnum[keyof typeof DestroyBrandRequestTypeEnum];

/**
 * ブランド削除
 * @export
 * @interface DestroyBrandResponse
 */
export interface DestroyBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyBrandResponse
     */
    'type': DestroyBrandResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyBrandResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyBrandResponseTypeEnum = {
    DestroyBrand: 'DestroyBrand'
} as const;

export type DestroyBrandResponseTypeEnum = typeof DestroyBrandResponseTypeEnum[keyof typeof DestroyBrandResponseTypeEnum];

/**
 * カテゴリー削除
 * @export
 * @interface DestroyCategoryRequest
 */
export interface DestroyCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyCategoryRequest
     */
    'type': DestroyCategoryRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyCategoryRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyCategoryRequestTypeEnum = {
    DestroyCategory: 'DestroyCategory'
} as const;

export type DestroyCategoryRequestTypeEnum = typeof DestroyCategoryRequestTypeEnum[keyof typeof DestroyCategoryRequestTypeEnum];

/**
 * カテゴリー削除
 * @export
 * @interface DestroyCategoryResponse
 */
export interface DestroyCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyCategoryResponse
     */
    'type': DestroyCategoryResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyCategoryResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyCategoryResponseTypeEnum = {
    DestroyCategory: 'DestroyCategory'
} as const;

export type DestroyCategoryResponseTypeEnum = typeof DestroyCategoryResponseTypeEnum[keyof typeof DestroyCategoryResponseTypeEnum];

/**
 * 会員削除
 * @export
 * @interface DestroyCustomerRequest
 */
export interface DestroyCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyCustomerRequest
     */
    'type': DestroyCustomerRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyCustomerRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyCustomerRequestTypeEnum = {
    DestroyCustomer: 'DestroyCustomer'
} as const;

export type DestroyCustomerRequestTypeEnum = typeof DestroyCustomerRequestTypeEnum[keyof typeof DestroyCustomerRequestTypeEnum];

/**
 * 会員削除
 * @export
 * @interface DestroyCustomerResponse
 */
export interface DestroyCustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyCustomerResponse
     */
    'type': DestroyCustomerResponseTypeEnum;
    /**
     * 
     * @type {CreateCustomerResponseData}
     * @memberof DestroyCustomerResponse
     */
    'data': CreateCustomerResponseData;
}

export const DestroyCustomerResponseTypeEnum = {
    DestroyCustomer: 'DestroyCustomer'
} as const;

export type DestroyCustomerResponseTypeEnum = typeof DestroyCustomerResponseTypeEnum[keyof typeof DestroyCustomerResponseTypeEnum];

/**
 * 全体通知更新
 * @export
 * @interface DestroyGlobalNotificationRequest
 */
export interface DestroyGlobalNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyGlobalNotificationRequest
     */
    'type': DestroyGlobalNotificationRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyGlobalNotificationRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyGlobalNotificationRequestTypeEnum = {
    DestroyGlobalNotification: 'DestroyGlobalNotification'
} as const;

export type DestroyGlobalNotificationRequestTypeEnum = typeof DestroyGlobalNotificationRequestTypeEnum[keyof typeof DestroyGlobalNotificationRequestTypeEnum];

/**
 * 全体通知更新
 * @export
 * @interface DestroyGlobalNotificationResponse
 */
export interface DestroyGlobalNotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyGlobalNotificationResponse
     */
    'type': DestroyGlobalNotificationResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof DestroyGlobalNotificationResponse
     */
    'data': CreateAdResponseData;
}

export const DestroyGlobalNotificationResponseTypeEnum = {
    DestroyGlobalNotification: 'DestroyGlobalNotification'
} as const;

export type DestroyGlobalNotificationResponseTypeEnum = typeof DestroyGlobalNotificationResponseTypeEnum[keyof typeof DestroyGlobalNotificationResponseTypeEnum];

/**
 * メールマガジンテンプレート削除
 * @export
 * @interface DestroyMagazineTemplateRequest
 */
export interface DestroyMagazineTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyMagazineTemplateRequest
     */
    'type': DestroyMagazineTemplateRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyMagazineTemplateRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyMagazineTemplateRequestTypeEnum = {
    DestroyMagazineTemplate: 'DestroyMagazineTemplate'
} as const;

export type DestroyMagazineTemplateRequestTypeEnum = typeof DestroyMagazineTemplateRequestTypeEnum[keyof typeof DestroyMagazineTemplateRequestTypeEnum];

/**
 * メールマガジンテンプレート削除
 * @export
 * @interface DestroyMagazineTemplateResponse
 */
export interface DestroyMagazineTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyMagazineTemplateResponse
     */
    'type': DestroyMagazineTemplateResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyMagazineTemplateResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyMagazineTemplateResponseTypeEnum = {
    DestroyMagazineTemplate: 'DestroyMagazineTemplate'
} as const;

export type DestroyMagazineTemplateResponseTypeEnum = typeof DestroyMagazineTemplateResponseTypeEnum[keyof typeof DestroyMagazineTemplateResponseTypeEnum];

/**
 * メーカー削除
 * @export
 * @interface DestroyMakerRequest
 */
export interface DestroyMakerRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyMakerRequest
     */
    'type': DestroyMakerRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyMakerRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyMakerRequestTypeEnum = {
    DestroyMaker: 'DestroyMaker'
} as const;

export type DestroyMakerRequestTypeEnum = typeof DestroyMakerRequestTypeEnum[keyof typeof DestroyMakerRequestTypeEnum];

/**
 * メーカー削除
 * @export
 * @interface DestroyMakerResponse
 */
export interface DestroyMakerResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyMakerResponse
     */
    'type': DestroyMakerResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyMakerResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyMakerResponseTypeEnum = {
    DestroyMaker: 'DestroyMaker'
} as const;

export type DestroyMakerResponseTypeEnum = typeof DestroyMakerResponseTypeEnum[keyof typeof DestroyMakerResponseTypeEnum];

/**
 * COSMEbi管理者削除
 * @export
 * @interface DestroyManagerRequest
 */
export interface DestroyManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyManagerRequest
     */
    'type': DestroyManagerRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyManagerRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyManagerRequestTypeEnum = {
    DestroyManager: 'DestroyManager'
} as const;

export type DestroyManagerRequestTypeEnum = typeof DestroyManagerRequestTypeEnum[keyof typeof DestroyManagerRequestTypeEnum];

/**
 * COSMEbi管理者削除
 * @export
 * @interface DestroyManagerResponse
 */
export interface DestroyManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyManagerResponse
     */
    'type': DestroyManagerResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyManagerResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyManagerResponseTypeEnum = {
    DestroyManager: 'DestroyManager'
} as const;

export type DestroyManagerResponseTypeEnum = typeof DestroyManagerResponseTypeEnum[keyof typeof DestroyManagerResponseTypeEnum];

/**
 * おすすめ商品削除
 * @export
 * @interface DestroyProductRecommendRequest
 */
export interface DestroyProductRecommendRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyProductRecommendRequest
     */
    'type': DestroyProductRecommendRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyProductRecommendRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyProductRecommendRequestTypeEnum = {
    DestroyProductRecommend: 'DestroyProductRecommend'
} as const;

export type DestroyProductRecommendRequestTypeEnum = typeof DestroyProductRecommendRequestTypeEnum[keyof typeof DestroyProductRecommendRequestTypeEnum];

/**
 * おすすめ商品削除
 * @export
 * @interface DestroyProductRecommendResponse
 */
export interface DestroyProductRecommendResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyProductRecommendResponse
     */
    'type': DestroyProductRecommendResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyProductRecommendResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyProductRecommendResponseTypeEnum = {
    DestroyProductRecommend: 'DestroyProductRecommend'
} as const;

export type DestroyProductRecommendResponseTypeEnum = typeof DestroyProductRecommendResponseTypeEnum[keyof typeof DestroyProductRecommendResponseTypeEnum];

/**
 * クチコミ削除
 * @export
 * @interface DestroyProductReviewRequest
 */
export interface DestroyProductReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyProductReviewRequest
     */
    'type': DestroyProductReviewRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyProductReviewRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyProductReviewRequestTypeEnum = {
    DestroyProductReview: 'DestroyProductReview'
} as const;

export type DestroyProductReviewRequestTypeEnum = typeof DestroyProductReviewRequestTypeEnum[keyof typeof DestroyProductReviewRequestTypeEnum];

/**
 * クチコミ削除
 * @export
 * @interface DestroyProductReviewResponse
 */
export interface DestroyProductReviewResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyProductReviewResponse
     */
    'type': DestroyProductReviewResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof DestroyProductReviewResponse
     */
    'data': CreateAdResponseData;
}

export const DestroyProductReviewResponseTypeEnum = {
    DestroyProductReview: 'DestroyProductReview'
} as const;

export type DestroyProductReviewResponseTypeEnum = typeof DestroyProductReviewResponseTypeEnum[keyof typeof DestroyProductReviewResponseTypeEnum];

/**
 * Q&A回答削除
 * @export
 * @interface DestroyQaAnswerRequest
 */
export interface DestroyQaAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyQaAnswerRequest
     */
    'type': DestroyQaAnswerRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyQaAnswerRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyQaAnswerRequestTypeEnum = {
    DestroyQaAnswer: 'DestroyQaAnswer'
} as const;

export type DestroyQaAnswerRequestTypeEnum = typeof DestroyQaAnswerRequestTypeEnum[keyof typeof DestroyQaAnswerRequestTypeEnum];

/**
 * Q&A回答削除
 * @export
 * @interface DestroyQaAnswerResponse
 */
export interface DestroyQaAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyQaAnswerResponse
     */
    'type': DestroyQaAnswerResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyQaAnswerResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyQaAnswerResponseTypeEnum = {
    DestroyQaAnswer: 'DestroyQaAnswer'
} as const;

export type DestroyQaAnswerResponseTypeEnum = typeof DestroyQaAnswerResponseTypeEnum[keyof typeof DestroyQaAnswerResponseTypeEnum];

/**
 * Q&A削除
 * @export
 * @interface DestroyQaRequest
 */
export interface DestroyQaRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyQaRequest
     */
    'type': DestroyQaRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyQaRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyQaRequestTypeEnum = {
    DestroyQa: 'DestroyQa'
} as const;

export type DestroyQaRequestTypeEnum = typeof DestroyQaRequestTypeEnum[keyof typeof DestroyQaRequestTypeEnum];

/**
 * Q&A削除
 * @export
 * @interface DestroyQaResponse
 */
export interface DestroyQaResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyQaResponse
     */
    'type': DestroyQaResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyQaResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyQaResponseTypeEnum = {
    DestroyQa: 'DestroyQa'
} as const;

export type DestroyQaResponseTypeEnum = typeof DestroyQaResponseTypeEnum[keyof typeof DestroyQaResponseTypeEnum];

/**
 * 美容レポ削除
 * @export
 * @interface DestroyReportRequest
 */
export interface DestroyReportRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyReportRequest
     */
    'type': DestroyReportRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyReportRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyReportRequestTypeEnum = {
    DestroyReport: 'DestroyReport'
} as const;

export type DestroyReportRequestTypeEnum = typeof DestroyReportRequestTypeEnum[keyof typeof DestroyReportRequestTypeEnum];

/**
 * 美容レポ削除
 * @export
 * @interface DestroyReportResponse
 */
export interface DestroyReportResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyReportResponse
     */
    'type': DestroyReportResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyReportResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyReportResponseTypeEnum = {
    DestroyReport: 'DestroyReport'
} as const;

export type DestroyReportResponseTypeEnum = typeof DestroyReportResponseTypeEnum[keyof typeof DestroyReportResponseTypeEnum];

/**
 * タグ削除
 * @export
 * @interface DestroyTagRequest
 */
export interface DestroyTagRequest {
    /**
     * 
     * @type {string}
     * @memberof DestroyTagRequest
     */
    'type': DestroyTagRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof DestroyTagRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const DestroyTagRequestTypeEnum = {
    DestroyTag: 'DestroyTag'
} as const;

export type DestroyTagRequestTypeEnum = typeof DestroyTagRequestTypeEnum[keyof typeof DestroyTagRequestTypeEnum];

/**
 * タグ削除
 * @export
 * @interface DestroyTagResponse
 */
export interface DestroyTagResponse {
    /**
     * 
     * @type {string}
     * @memberof DestroyTagResponse
     */
    'type': DestroyTagResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof DestroyTagResponse
     */
    'data': DestroyAdResponseData;
}

export const DestroyTagResponseTypeEnum = {
    DestroyTag: 'DestroyTag'
} as const;

export type DestroyTagResponseTypeEnum = typeof DestroyTagResponseTypeEnum[keyof typeof DestroyTagResponseTypeEnum];

/**
 * 
 * @export
 * @interface GlobalNotification
 */
export interface GlobalNotification {
    /**
     * 
     * @type {number}
     * @memberof GlobalNotification
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GlobalNotification
     */
    'notifiedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalNotification
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalNotification
     */
    'linkType'?: GlobalNotificationLinkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GlobalNotification
     */
    'linkValue'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalNotification
     */
    'childrenCreated'?: boolean;
}

export const GlobalNotificationLinkTypeEnum = {
    Info: 'info'
} as const;

export type GlobalNotificationLinkTypeEnum = typeof GlobalNotificationLinkTypeEnum[keyof typeof GlobalNotificationLinkTypeEnum];

/**
 * 広告一覧
 * @export
 * @interface IndexAdsRequest
 */
export interface IndexAdsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexAdsRequest
     */
    'type': IndexAdsRequestTypeEnum;
    /**
     * 
     * @type {IndexAdsRequestData}
     * @memberof IndexAdsRequest
     */
    'data': IndexAdsRequestData;
}

export const IndexAdsRequestTypeEnum = {
    IndexAds: 'IndexAds'
} as const;

export type IndexAdsRequestTypeEnum = typeof IndexAdsRequestTypeEnum[keyof typeof IndexAdsRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexAdsRequestData
 */
export interface IndexAdsRequestData {
    /**
     * 有効な広告だけを取得
     * @type {boolean}
     * @memberof IndexAdsRequestData
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IndexAdsRequestData
     */
    'adType'?: IndexAdsRequestDataAdTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IndexAdsRequestData
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexAdsRequestData
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexAdsRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexAdsRequestData
     */
    'per'?: number;
}

export const IndexAdsRequestDataAdTypeEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E'
} as const;

export type IndexAdsRequestDataAdTypeEnum = typeof IndexAdsRequestDataAdTypeEnum[keyof typeof IndexAdsRequestDataAdTypeEnum];

/**
 * 広告一覧
 * @export
 * @interface IndexAdsResponse
 */
export interface IndexAdsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexAdsResponse
     */
    'type': IndexAdsResponseTypeEnum;
    /**
     * 
     * @type {IndexAdsResponseData}
     * @memberof IndexAdsResponse
     */
    'data': IndexAdsResponseData;
}

export const IndexAdsResponseTypeEnum = {
    IndexAds: 'IndexAds'
} as const;

export type IndexAdsResponseTypeEnum = typeof IndexAdsResponseTypeEnum[keyof typeof IndexAdsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexAdsResponseData
 */
export interface IndexAdsResponseData {
    /**
     * 
     * @type {Array<Ad>}
     * @memberof IndexAdsResponseData
     */
    'ads': Array<Ad>;
    /**
     * 
     * @type {number}
     * @memberof IndexAdsResponseData
     */
    'count': number;
}
/**
 * ブランド一覧
 * @export
 * @interface IndexBrandsRequest
 */
export interface IndexBrandsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexBrandsRequest
     */
    'type': IndexBrandsRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexBrandsRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexBrandsRequestTypeEnum = {
    IndexBrands: 'IndexBrands'
} as const;

export type IndexBrandsRequestTypeEnum = typeof IndexBrandsRequestTypeEnum[keyof typeof IndexBrandsRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexBrandsRequestData
 */
export interface IndexBrandsRequestData {
    /**
     * 
     * @type {string}
     * @memberof IndexBrandsRequestData
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexBrandsRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexBrandsRequestData
     */
    'per'?: number;
}
/**
 * ブランド一覧
 * @export
 * @interface IndexBrandsResponse
 */
export interface IndexBrandsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexBrandsResponse
     */
    'type': IndexBrandsResponseTypeEnum;
    /**
     * 
     * @type {IndexBrandsResponseData}
     * @memberof IndexBrandsResponse
     */
    'data': IndexBrandsResponseData;
}

export const IndexBrandsResponseTypeEnum = {
    IndexBrands: 'IndexBrands'
} as const;

export type IndexBrandsResponseTypeEnum = typeof IndexBrandsResponseTypeEnum[keyof typeof IndexBrandsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexBrandsResponseData
 */
export interface IndexBrandsResponseData {
    /**
     * 
     * @type {Array<Brand>}
     * @memberof IndexBrandsResponseData
     */
    'brands': Array<Brand>;
    /**
     * 
     * @type {number}
     * @memberof IndexBrandsResponseData
     */
    'count': number;
}
/**
 * カテゴリー一覧
 * @export
 * @interface IndexCategoriesRequest
 */
export interface IndexCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexCategoriesRequest
     */
    'type': IndexCategoriesRequestTypeEnum;
    /**
     * 
     * @type {IndexCategoriesRequestData}
     * @memberof IndexCategoriesRequest
     */
    'data': IndexCategoriesRequestData;
}

export const IndexCategoriesRequestTypeEnum = {
    IndexCategories: 'IndexCategories'
} as const;

export type IndexCategoriesRequestTypeEnum = typeof IndexCategoriesRequestTypeEnum[keyof typeof IndexCategoriesRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexCategoriesRequestData
 */
export interface IndexCategoriesRequestData {
    /**
     * 
     * @type {number}
     * @memberof IndexCategoriesRequestData
     */
    'parentCategoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexCategoriesRequestData
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexCategoriesRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexCategoriesRequestData
     */
    'per'?: number;
    /**
     * すべてを取得する
     * @type {boolean}
     * @memberof IndexCategoriesRequestData
     */
    'all'?: boolean;
}
/**
 * カテゴリー一覧
 * @export
 * @interface IndexCategoriesResponse
 */
export interface IndexCategoriesResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexCategoriesResponse
     */
    'type': IndexCategoriesResponseTypeEnum;
    /**
     * 
     * @type {IndexCategoriesResponseData}
     * @memberof IndexCategoriesResponse
     */
    'data': IndexCategoriesResponseData;
}

export const IndexCategoriesResponseTypeEnum = {
    IndexCategories: 'IndexCategories'
} as const;

export type IndexCategoriesResponseTypeEnum = typeof IndexCategoriesResponseTypeEnum[keyof typeof IndexCategoriesResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexCategoriesResponseData
 */
export interface IndexCategoriesResponseData {
    /**
     * 
     * @type {Array<Category>}
     * @memberof IndexCategoriesResponseData
     */
    'categories': Array<Category>;
    /**
     * 
     * @type {Array<Category>}
     * @memberof IndexCategoriesResponseData
     */
    'breadcrumbs': Array<Category>;
    /**
     * 
     * @type {number}
     * @memberof IndexCategoriesResponseData
     */
    'count': number;
}
/**
 * チャネル一覧
 * @export
 * @interface IndexChanelsRequest
 */
export interface IndexChanelsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexChanelsRequest
     */
    'type': IndexChanelsRequestTypeEnum;
}

export const IndexChanelsRequestTypeEnum = {
    IndexChanels: 'IndexChanels'
} as const;

export type IndexChanelsRequestTypeEnum = typeof IndexChanelsRequestTypeEnum[keyof typeof IndexChanelsRequestTypeEnum];

/**
 * チャネル一覧
 * @export
 * @interface IndexChanelsResponse
 */
export interface IndexChanelsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexChanelsResponse
     */
    'type': IndexChanelsResponseTypeEnum;
    /**
     * 
     * @type {IndexChanelsResponseData}
     * @memberof IndexChanelsResponse
     */
    'data': IndexChanelsResponseData;
}

export const IndexChanelsResponseTypeEnum = {
    IndexChanels: 'IndexChanels'
} as const;

export type IndexChanelsResponseTypeEnum = typeof IndexChanelsResponseTypeEnum[keyof typeof IndexChanelsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexChanelsResponseData
 */
export interface IndexChanelsResponseData {
    /**
     * 
     * @type {Array<Chanel>}
     * @memberof IndexChanelsResponseData
     */
    'chanels': Array<Chanel>;
}
/**
 * 会員一覧
 * @export
 * @interface IndexCustomersRequest
 */
export interface IndexCustomersRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequest
     */
    'type': IndexCustomersRequestTypeEnum;
    /**
     * 
     * @type {IndexCustomersRequestData}
     * @memberof IndexCustomersRequest
     */
    'data': IndexCustomersRequestData;
}

export const IndexCustomersRequestTypeEnum = {
    IndexCustomers: 'IndexCustomers'
} as const;

export type IndexCustomersRequestTypeEnum = typeof IndexCustomersRequestTypeEnum[keyof typeof IndexCustomersRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexCustomersRequestData
 */
export interface IndexCustomersRequestData {
    /**
     * 
     * @type {Array<CustomerStatus>}
     * @memberof IndexCustomersRequestData
     */
    'customerStatuses'?: Array<CustomerStatus>;
    /**
     * 
     * @type {Array<OfficialStatus>}
     * @memberof IndexCustomersRequestData
     */
    'officialStatuses'?: Array<OfficialStatus>;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'birthFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'birthTill'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexCustomersRequestData
     */
    'prefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'createDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'createDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'updateDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'updateDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersRequestData
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexCustomersRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexCustomersRequestData
     */
    'per'?: number;
}
/**
 * 会員一覧
 * @export
 * @interface IndexCustomersResponse
 */
export interface IndexCustomersResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexCustomersResponse
     */
    'type': IndexCustomersResponseTypeEnum;
    /**
     * 
     * @type {IndexCustomersResponseData}
     * @memberof IndexCustomersResponse
     */
    'data': IndexCustomersResponseData;
}

export const IndexCustomersResponseTypeEnum = {
    IndexCustomers: 'IndexCustomers'
} as const;

export type IndexCustomersResponseTypeEnum = typeof IndexCustomersResponseTypeEnum[keyof typeof IndexCustomersResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexCustomersResponseData
 */
export interface IndexCustomersResponseData {
    /**
     * 
     * @type {Array<Customer>}
     * @memberof IndexCustomersResponseData
     */
    'customers': Array<Customer>;
    /**
     * 
     * @type {number}
     * @memberof IndexCustomersResponseData
     */
    'count': number;
}
/**
 * 全体通知一覧
 * @export
 * @interface IndexGlobalNotificationsRequest
 */
export interface IndexGlobalNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexGlobalNotificationsRequest
     */
    'type': IndexGlobalNotificationsRequestTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof IndexGlobalNotificationsRequest
     */
    'data': object;
}

export const IndexGlobalNotificationsRequestTypeEnum = {
    IndexGlobalNotifications: 'IndexGlobalNotifications'
} as const;

export type IndexGlobalNotificationsRequestTypeEnum = typeof IndexGlobalNotificationsRequestTypeEnum[keyof typeof IndexGlobalNotificationsRequestTypeEnum];

/**
 * 全体通知一覧
 * @export
 * @interface IndexGlobalNotificationsResponse
 */
export interface IndexGlobalNotificationsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexGlobalNotificationsResponse
     */
    'type': IndexGlobalNotificationsResponseTypeEnum;
    /**
     * 
     * @type {IndexGlobalNotificationsResponseData}
     * @memberof IndexGlobalNotificationsResponse
     */
    'data': IndexGlobalNotificationsResponseData;
}

export const IndexGlobalNotificationsResponseTypeEnum = {
    IndexGlobalNotifications: 'IndexGlobalNotifications'
} as const;

export type IndexGlobalNotificationsResponseTypeEnum = typeof IndexGlobalNotificationsResponseTypeEnum[keyof typeof IndexGlobalNotificationsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexGlobalNotificationsResponseData
 */
export interface IndexGlobalNotificationsResponseData {
    /**
     * 
     * @type {Array<GlobalNotification>}
     * @memberof IndexGlobalNotificationsResponseData
     */
    'globalNotifications': Array<GlobalNotification>;
    /**
     * 
     * @type {number}
     * @memberof IndexGlobalNotificationsResponseData
     */
    'count': number;
}
/**
 * 好み・関心一覧
 * @export
 * @interface IndexInterestsRequest
 */
export interface IndexInterestsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexInterestsRequest
     */
    'type': IndexInterestsRequestTypeEnum;
}

export const IndexInterestsRequestTypeEnum = {
    IndexInterests: 'IndexInterests'
} as const;

export type IndexInterestsRequestTypeEnum = typeof IndexInterestsRequestTypeEnum[keyof typeof IndexInterestsRequestTypeEnum];

/**
 * 好み・関心一覧
 * @export
 * @interface IndexInterestsResponse
 */
export interface IndexInterestsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexInterestsResponse
     */
    'type': IndexInterestsResponseTypeEnum;
    /**
     * 
     * @type {IndexInterestsResponseData}
     * @memberof IndexInterestsResponse
     */
    'data': IndexInterestsResponseData;
}

export const IndexInterestsResponseTypeEnum = {
    IndexInterests: 'IndexInterests'
} as const;

export type IndexInterestsResponseTypeEnum = typeof IndexInterestsResponseTypeEnum[keyof typeof IndexInterestsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexInterestsResponseData
 */
export interface IndexInterestsResponseData {
    /**
     * 
     * @type {Array<Interest>}
     * @memberof IndexInterestsResponseData
     */
    'interests': Array<Interest>;
}
/**
 * こだわり一覧
 * @export
 * @interface IndexKodawarisRequest
 */
export interface IndexKodawarisRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexKodawarisRequest
     */
    'type': IndexKodawarisRequestTypeEnum;
}

export const IndexKodawarisRequestTypeEnum = {
    IndexKodawaris: 'IndexKodawaris'
} as const;

export type IndexKodawarisRequestTypeEnum = typeof IndexKodawarisRequestTypeEnum[keyof typeof IndexKodawarisRequestTypeEnum];

/**
 * こだわり一覧
 * @export
 * @interface IndexKodawarisResponse
 */
export interface IndexKodawarisResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexKodawarisResponse
     */
    'type': IndexKodawarisResponseTypeEnum;
    /**
     * 
     * @type {IndexKodawarisResponseData}
     * @memberof IndexKodawarisResponse
     */
    'data': IndexKodawarisResponseData;
}

export const IndexKodawarisResponseTypeEnum = {
    IndexKodawaris: 'IndexKodawaris'
} as const;

export type IndexKodawarisResponseTypeEnum = typeof IndexKodawarisResponseTypeEnum[keyof typeof IndexKodawarisResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexKodawarisResponseData
 */
export interface IndexKodawarisResponseData {
    /**
     * 
     * @type {Array<Kodawari>}
     * @memberof IndexKodawarisResponseData
     */
    'kodawaris': Array<Kodawari>;
}
/**
 * メールマガジン受信者一覧
 * @export
 * @interface IndexMailMagazineCustomersRequest
 */
export interface IndexMailMagazineCustomersRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexMailMagazineCustomersRequest
     */
    'type': IndexMailMagazineCustomersRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexMailMagazineCustomersRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexMailMagazineCustomersRequestTypeEnum = {
    IndexMailMagazineCustomers: 'IndexMailMagazineCustomers'
} as const;

export type IndexMailMagazineCustomersRequestTypeEnum = typeof IndexMailMagazineCustomersRequestTypeEnum[keyof typeof IndexMailMagazineCustomersRequestTypeEnum];

/**
 * メールマガジン受信者一覧
 * @export
 * @interface IndexMailMagazineCustomersResponse
 */
export interface IndexMailMagazineCustomersResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexMailMagazineCustomersResponse
     */
    'type': IndexMailMagazineCustomersResponseTypeEnum;
    /**
     * 
     * @type {IndexCustomersResponseData}
     * @memberof IndexMailMagazineCustomersResponse
     */
    'data': IndexCustomersResponseData;
}

export const IndexMailMagazineCustomersResponseTypeEnum = {
    IndexMailMagazineCustomers: 'IndexMailMagazineCustomers'
} as const;

export type IndexMailMagazineCustomersResponseTypeEnum = typeof IndexMailMagazineCustomersResponseTypeEnum[keyof typeof IndexMailMagazineCustomersResponseTypeEnum];

/**
 * メールマガジン送信履歴一覧
 * @export
 * @interface IndexMailMagazineHistoriesRequest
 */
export interface IndexMailMagazineHistoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexMailMagazineHistoriesRequest
     */
    'type': IndexMailMagazineHistoriesRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexMailMagazineHistoriesRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexMailMagazineHistoriesRequestTypeEnum = {
    IndexMagazineHistories: 'IndexMagazineHistories'
} as const;

export type IndexMailMagazineHistoriesRequestTypeEnum = typeof IndexMailMagazineHistoriesRequestTypeEnum[keyof typeof IndexMailMagazineHistoriesRequestTypeEnum];

/**
 * メールマガジン送信履歴一覧
 * @export
 * @interface IndexMailMagazineHistoriesResponse
 */
export interface IndexMailMagazineHistoriesResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexMailMagazineHistoriesResponse
     */
    'type': IndexMailMagazineHistoriesResponseTypeEnum;
    /**
     * 
     * @type {IndexMailMagazineHistoriesResponseData}
     * @memberof IndexMailMagazineHistoriesResponse
     */
    'data': IndexMailMagazineHistoriesResponseData;
}

export const IndexMailMagazineHistoriesResponseTypeEnum = {
    IndexMagazineHistories: 'IndexMagazineHistories'
} as const;

export type IndexMailMagazineHistoriesResponseTypeEnum = typeof IndexMailMagazineHistoriesResponseTypeEnum[keyof typeof IndexMailMagazineHistoriesResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexMailMagazineHistoriesResponseData
 */
export interface IndexMailMagazineHistoriesResponseData {
    /**
     * 
     * @type {Array<MailMagazineHistory>}
     * @memberof IndexMailMagazineHistoriesResponseData
     */
    'histories': Array<MailMagazineHistory>;
    /**
     * 
     * @type {number}
     * @memberof IndexMailMagazineHistoriesResponseData
     */
    'count': number;
}
/**
 * メールマガジンテンプレート一覧
 * @export
 * @interface IndexMailMagazineTemplatesRequest
 */
export interface IndexMailMagazineTemplatesRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexMailMagazineTemplatesRequest
     */
    'type': IndexMailMagazineTemplatesRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexMailMagazineTemplatesRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexMailMagazineTemplatesRequestTypeEnum = {
    IndexMailMagazineTemplates: 'IndexMailMagazineTemplates'
} as const;

export type IndexMailMagazineTemplatesRequestTypeEnum = typeof IndexMailMagazineTemplatesRequestTypeEnum[keyof typeof IndexMailMagazineTemplatesRequestTypeEnum];

/**
 * メールマガジンテンプレート一覧
 * @export
 * @interface IndexMailMagazineTemplatesResponse
 */
export interface IndexMailMagazineTemplatesResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexMailMagazineTemplatesResponse
     */
    'type': IndexMailMagazineTemplatesResponseTypeEnum;
    /**
     * 
     * @type {IndexMailMagazineTemplatesResponseData}
     * @memberof IndexMailMagazineTemplatesResponse
     */
    'data': IndexMailMagazineTemplatesResponseData;
}

export const IndexMailMagazineTemplatesResponseTypeEnum = {
    IndexMailMagazineTemplates: 'IndexMailMagazineTemplates'
} as const;

export type IndexMailMagazineTemplatesResponseTypeEnum = typeof IndexMailMagazineTemplatesResponseTypeEnum[keyof typeof IndexMailMagazineTemplatesResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexMailMagazineTemplatesResponseData
 */
export interface IndexMailMagazineTemplatesResponseData {
    /**
     * 
     * @type {Array<MailMagazineTemplate>}
     * @memberof IndexMailMagazineTemplatesResponseData
     */
    'templates': Array<MailMagazineTemplate>;
    /**
     * 
     * @type {number}
     * @memberof IndexMailMagazineTemplatesResponseData
     */
    'count': number;
}
/**
 * メーカー一覧
 * @export
 * @interface IndexMakersRequest
 */
export interface IndexMakersRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexMakersRequest
     */
    'type': IndexMakersRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexMakersRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexMakersRequestTypeEnum = {
    IndexMakers: 'IndexMakers'
} as const;

export type IndexMakersRequestTypeEnum = typeof IndexMakersRequestTypeEnum[keyof typeof IndexMakersRequestTypeEnum];

/**
 * メーカー一覧
 * @export
 * @interface IndexMakersResponse
 */
export interface IndexMakersResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexMakersResponse
     */
    'type': IndexMakersResponseTypeEnum;
    /**
     * 
     * @type {IndexMakersResponseData}
     * @memberof IndexMakersResponse
     */
    'data': IndexMakersResponseData;
}

export const IndexMakersResponseTypeEnum = {
    IndexMakers: 'IndexMakers'
} as const;

export type IndexMakersResponseTypeEnum = typeof IndexMakersResponseTypeEnum[keyof typeof IndexMakersResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexMakersResponseData
 */
export interface IndexMakersResponseData {
    /**
     * 
     * @type {Array<Maker>}
     * @memberof IndexMakersResponseData
     */
    'makers': Array<Maker>;
    /**
     * 
     * @type {number}
     * @memberof IndexMakersResponseData
     */
    'count': number;
}
/**
 * COSMEbi管理者一覧
 * @export
 * @interface IndexManagersRequest
 */
export interface IndexManagersRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexManagersRequest
     */
    'type': IndexManagersRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexManagersRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexManagersRequestTypeEnum = {
    IndexManagers: 'IndexManagers'
} as const;

export type IndexManagersRequestTypeEnum = typeof IndexManagersRequestTypeEnum[keyof typeof IndexManagersRequestTypeEnum];

/**
 * COSMEbi管理者一覧
 * @export
 * @interface IndexManagersResponse
 */
export interface IndexManagersResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexManagersResponse
     */
    'type': IndexManagersResponseTypeEnum;
    /**
     * 
     * @type {IndexManagersResponseData}
     * @memberof IndexManagersResponse
     */
    'data': IndexManagersResponseData;
}

export const IndexManagersResponseTypeEnum = {
    IndexManagers: 'IndexManagers'
} as const;

export type IndexManagersResponseTypeEnum = typeof IndexManagersResponseTypeEnum[keyof typeof IndexManagersResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexManagersResponseData
 */
export interface IndexManagersResponseData {
    /**
     * 
     * @type {Array<Manager>}
     * @memberof IndexManagersResponseData
     */
    'managers': Array<Manager>;
    /**
     * 
     * @type {number}
     * @memberof IndexManagersResponseData
     */
    'count': number;
}
/**
 * 都道府県一覧
 * @export
 * @interface IndexPrefsRequest
 */
export interface IndexPrefsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexPrefsRequest
     */
    'type': IndexPrefsRequestTypeEnum;
}

export const IndexPrefsRequestTypeEnum = {
    IndexPrefs: 'IndexPrefs'
} as const;

export type IndexPrefsRequestTypeEnum = typeof IndexPrefsRequestTypeEnum[keyof typeof IndexPrefsRequestTypeEnum];

/**
 * 都道府県一覧
 * @export
 * @interface IndexPrefsResponse
 */
export interface IndexPrefsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexPrefsResponse
     */
    'type': IndexPrefsResponseTypeEnum;
    /**
     * 
     * @type {IndexPrefsResponseData}
     * @memberof IndexPrefsResponse
     */
    'data': IndexPrefsResponseData;
}

export const IndexPrefsResponseTypeEnum = {
    IndexPrefs: 'IndexPrefs'
} as const;

export type IndexPrefsResponseTypeEnum = typeof IndexPrefsResponseTypeEnum[keyof typeof IndexPrefsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexPrefsResponseData
 */
export interface IndexPrefsResponseData {
    /**
     * 
     * @type {Array<Pref>}
     * @memberof IndexPrefsResponseData
     */
    'prefs': Array<Pref>;
}
/**
 * プレゼント・モニター一覧
 * @export
 * @interface IndexPresentCampaignsRequest
 */
export interface IndexPresentCampaignsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexPresentCampaignsRequest
     */
    'type': IndexPresentCampaignsRequestTypeEnum;
    /**
     * 
     * @type {IndexPresentCampaignsRequestData}
     * @memberof IndexPresentCampaignsRequest
     */
    'data': IndexPresentCampaignsRequestData;
}

export const IndexPresentCampaignsRequestTypeEnum = {
    IndexPresentCampaigns: 'IndexPresentCampaigns'
} as const;

export type IndexPresentCampaignsRequestTypeEnum = typeof IndexPresentCampaignsRequestTypeEnum[keyof typeof IndexPresentCampaignsRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexPresentCampaignsRequestData
 */
export interface IndexPresentCampaignsRequestData {
    /**
     * 
     * @type {number}
     * @memberof IndexPresentCampaignsRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexPresentCampaignsRequestData
     */
    'per'?: number;
}
/**
 * プレゼント・モニター一覧
 * @export
 * @interface IndexPresentCampaignsResponse
 */
export interface IndexPresentCampaignsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexPresentCampaignsResponse
     */
    'type': IndexPresentCampaignsResponseTypeEnum;
    /**
     * 
     * @type {IndexPresentCampaignsResponseData}
     * @memberof IndexPresentCampaignsResponse
     */
    'data': IndexPresentCampaignsResponseData;
}

export const IndexPresentCampaignsResponseTypeEnum = {
    IndexPresentCampaigns: 'IndexPresentCampaigns'
} as const;

export type IndexPresentCampaignsResponseTypeEnum = typeof IndexPresentCampaignsResponseTypeEnum[keyof typeof IndexPresentCampaignsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexPresentCampaignsResponseData
 */
export interface IndexPresentCampaignsResponseData {
    /**
     * 
     * @type {Array<PresentCampaign>}
     * @memberof IndexPresentCampaignsResponseData
     */
    'presentCampaigns': Array<PresentCampaign>;
    /**
     * 
     * @type {number}
     * @memberof IndexPresentCampaignsResponseData
     */
    'count': number;
}
/**
 * プレゼント・モニターCSVダウンロード
 * @export
 * @interface IndexPresentHistoriesRequest
 */
export interface IndexPresentHistoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexPresentHistoriesRequest
     */
    'type': IndexPresentHistoriesRequestTypeEnum;
    /**
     * 
     * @type {IndexPresentHistoriesRequestData}
     * @memberof IndexPresentHistoriesRequest
     */
    'data': IndexPresentHistoriesRequestData;
}

export const IndexPresentHistoriesRequestTypeEnum = {
    IndexPresentHistories: 'IndexPresentHistories'
} as const;

export type IndexPresentHistoriesRequestTypeEnum = typeof IndexPresentHistoriesRequestTypeEnum[keyof typeof IndexPresentHistoriesRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexPresentHistoriesRequestData
 */
export interface IndexPresentHistoriesRequestData {
    /**
     * 
     * @type {number}
     * @memberof IndexPresentHistoriesRequestData
     */
    'postId': number;
}
/**
 * プレゼント・モニターCSVダウンロード
 * @export
 * @interface IndexPresentHistoriesResponse
 */
export interface IndexPresentHistoriesResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexPresentHistoriesResponse
     */
    'type': IndexPresentHistoriesResponseTypeEnum;
    /**
     * 
     * @type {IndexPresentHistoriesResponseData}
     * @memberof IndexPresentHistoriesResponse
     */
    'data': IndexPresentHistoriesResponseData;
}

export const IndexPresentHistoriesResponseTypeEnum = {
    IndexPresentHistories: 'IndexPresentHistories'
} as const;

export type IndexPresentHistoriesResponseTypeEnum = typeof IndexPresentHistoriesResponseTypeEnum[keyof typeof IndexPresentHistoriesResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexPresentHistoriesResponseData
 */
export interface IndexPresentHistoriesResponseData {
    /**
     * 
     * @type {Array<PresentHistory>}
     * @memberof IndexPresentHistoriesResponseData
     */
    'presentHistories': Array<PresentHistory>;
}
/**
 * おすすめ商品一覧
 * @export
 * @interface IndexProductRecommendsRequest
 */
export interface IndexProductRecommendsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexProductRecommendsRequest
     */
    'type': IndexProductRecommendsRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexProductRecommendsRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexProductRecommendsRequestTypeEnum = {
    IndexProductRecommends: 'IndexProductRecommends'
} as const;

export type IndexProductRecommendsRequestTypeEnum = typeof IndexProductRecommendsRequestTypeEnum[keyof typeof IndexProductRecommendsRequestTypeEnum];

/**
 * おすすめ商品一覧
 * @export
 * @interface IndexProductRecommendsResponse
 */
export interface IndexProductRecommendsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexProductRecommendsResponse
     */
    'type': IndexProductRecommendsResponseTypeEnum;
    /**
     * 
     * @type {IndexProductRecommendsResponseData}
     * @memberof IndexProductRecommendsResponse
     */
    'data': IndexProductRecommendsResponseData;
}

export const IndexProductRecommendsResponseTypeEnum = {
    IndexProductRecommends: 'IndexProductRecommends'
} as const;

export type IndexProductRecommendsResponseTypeEnum = typeof IndexProductRecommendsResponseTypeEnum[keyof typeof IndexProductRecommendsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexProductRecommendsResponseData
 */
export interface IndexProductRecommendsResponseData {
    /**
     * 
     * @type {Array<ProductRecommend>}
     * @memberof IndexProductRecommendsResponseData
     */
    'productRecommends': Array<ProductRecommend>;
    /**
     * 
     * @type {number}
     * @memberof IndexProductRecommendsResponseData
     */
    'count': number;
}
/**
 * クチコミ一覧
 * @export
 * @interface IndexProductReviewsRequest
 */
export interface IndexProductReviewsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexProductReviewsRequest
     */
    'type': IndexProductReviewsRequestTypeEnum;
    /**
     * 
     * @type {IndexProductReviewsRequestData}
     * @memberof IndexProductReviewsRequest
     */
    'data': IndexProductReviewsRequestData;
}

export const IndexProductReviewsRequestTypeEnum = {
    IndexProductReviews: 'IndexProductReviews'
} as const;

export type IndexProductReviewsRequestTypeEnum = typeof IndexProductReviewsRequestTypeEnum[keyof typeof IndexProductReviewsRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexProductReviewsRequestData
 */
export interface IndexProductReviewsRequestData {
    /**
     * 
     * @type {string}
     * @memberof IndexProductReviewsRequestData
     */
    'productName'?: string;
    /**
     * 
     * @type {Array<UserContentStatus>}
     * @memberof IndexProductReviewsRequestData
     */
    'statuses'?: Array<UserContentStatus>;
    /**
     * 
     * @type {RecommendLevel}
     * @memberof IndexProductReviewsRequestData
     */
    'recommendLevel'?: RecommendLevel;
    /**
     * 
     * @type {string}
     * @memberof IndexProductReviewsRequestData
     */
    'applyDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductReviewsRequestData
     */
    'applyDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductReviewsRequestData
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexProductReviewsRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexProductReviewsRequestData
     */
    'per'?: number;
}
/**
 * クチコミ一覧
 * @export
 * @interface IndexProductReviewsResponse
 */
export interface IndexProductReviewsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexProductReviewsResponse
     */
    'type': IndexProductReviewsResponseTypeEnum;
    /**
     * 
     * @type {IndexProductReviewsResponseData}
     * @memberof IndexProductReviewsResponse
     */
    'data': IndexProductReviewsResponseData;
}

export const IndexProductReviewsResponseTypeEnum = {
    IndexProductReviews: 'IndexProductReviews'
} as const;

export type IndexProductReviewsResponseTypeEnum = typeof IndexProductReviewsResponseTypeEnum[keyof typeof IndexProductReviewsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexProductReviewsResponseData
 */
export interface IndexProductReviewsResponseData {
    /**
     * 
     * @type {Array<ProductReview>}
     * @memberof IndexProductReviewsResponseData
     */
    'productReviews': Array<ProductReview>;
    /**
     * 
     * @type {number}
     * @memberof IndexProductReviewsResponseData
     */
    'count': number;
}
/**
 * 商品一覧
 * @export
 * @interface IndexProductsRequest
 */
export interface IndexProductsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequest
     */
    'type': IndexProductsRequestTypeEnum;
    /**
     * 
     * @type {IndexProductsRequestData}
     * @memberof IndexProductsRequest
     */
    'data': IndexProductsRequestData;
}

export const IndexProductsRequestTypeEnum = {
    IndexProducts: 'IndexProducts'
} as const;

export type IndexProductsRequestTypeEnum = typeof IndexProductsRequestTypeEnum[keyof typeof IndexProductsRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexProductsRequestData
 */
export interface IndexProductsRequestData {
    /**
     * 
     * @type {Array<string>}
     * @memberof IndexProductsRequestData
     */
    'channels'?: Array<string>;
    /**
     * 
     * @type {Array<ProductStatus>}
     * @memberof IndexProductsRequestData
     */
    'statuses'?: Array<ProductStatus>;
    /**
     * 
     * @type {number}
     * @memberof IndexProductsRequestData
     */
    'categoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexProductsRequestData
     */
    'makerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexProductsRequestData
     */
    'brandId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequestData
     */
    'releaseDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequestData
     */
    'releaseDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequestData
     */
    'createDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequestData
     */
    'createDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequestData
     */
    'updateDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequestData
     */
    'updateDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexProductsRequestData
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexProductsRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexProductsRequestData
     */
    'per'?: number;
}
/**
 * 商品一覧
 * @export
 * @interface IndexProductsResponse
 */
export interface IndexProductsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexProductsResponse
     */
    'type': IndexProductsResponseTypeEnum;
    /**
     * 
     * @type {IndexProductsResponseData}
     * @memberof IndexProductsResponse
     */
    'data': IndexProductsResponseData;
}

export const IndexProductsResponseTypeEnum = {
    IndexProducts: 'IndexProducts'
} as const;

export type IndexProductsResponseTypeEnum = typeof IndexProductsResponseTypeEnum[keyof typeof IndexProductsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexProductsResponseData
 */
export interface IndexProductsResponseData {
    /**
     * 
     * @type {Array<Product>}
     * @memberof IndexProductsResponseData
     */
    'products': Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof IndexProductsResponseData
     */
    'count': number;
}
/**
 * Q&A回答一覧
 * @export
 * @interface IndexQaAnswersRequest
 */
export interface IndexQaAnswersRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexQaAnswersRequest
     */
    'type': IndexQaAnswersRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexQaAnswersRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexQaAnswersRequestTypeEnum = {
    IndexQaAnswers: 'IndexQaAnswers'
} as const;

export type IndexQaAnswersRequestTypeEnum = typeof IndexQaAnswersRequestTypeEnum[keyof typeof IndexQaAnswersRequestTypeEnum];

/**
 * Q&A回答一覧
 * @export
 * @interface IndexQaAnswersResponse
 */
export interface IndexQaAnswersResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexQaAnswersResponse
     */
    'type': IndexQaAnswersResponseTypeEnum;
    /**
     * 
     * @type {IndexQaAnswersResponseData}
     * @memberof IndexQaAnswersResponse
     */
    'data': IndexQaAnswersResponseData;
}

export const IndexQaAnswersResponseTypeEnum = {
    IndexQaAnswers: 'IndexQaAnswers'
} as const;

export type IndexQaAnswersResponseTypeEnum = typeof IndexQaAnswersResponseTypeEnum[keyof typeof IndexQaAnswersResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexQaAnswersResponseData
 */
export interface IndexQaAnswersResponseData {
    /**
     * 
     * @type {Array<QaAnswer>}
     * @memberof IndexQaAnswersResponseData
     */
    'qaAnswers': Array<QaAnswer>;
    /**
     * 
     * @type {number}
     * @memberof IndexQaAnswersResponseData
     */
    'count': number;
}
/**
 * Q&A一覧
 * @export
 * @interface IndexQasRequest
 */
export interface IndexQasRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexQasRequest
     */
    'type': IndexQasRequestTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof IndexQasRequest
     */
    'data': object;
    /**
     * 
     * @type {string}
     * @memberof IndexQasRequest
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexQasRequest
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexQasRequest
     */
    'per'?: number;
}

export const IndexQasRequestTypeEnum = {
    IndexQas: 'IndexQas'
} as const;

export type IndexQasRequestTypeEnum = typeof IndexQasRequestTypeEnum[keyof typeof IndexQasRequestTypeEnum];

/**
 * Q&A一覧
 * @export
 * @interface IndexQasResponse
 */
export interface IndexQasResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexQasResponse
     */
    'type': IndexQasResponseTypeEnum;
    /**
     * 
     * @type {IndexQasResponseData}
     * @memberof IndexQasResponse
     */
    'data': IndexQasResponseData;
}

export const IndexQasResponseTypeEnum = {
    IndexQas: 'IndexQas'
} as const;

export type IndexQasResponseTypeEnum = typeof IndexQasResponseTypeEnum[keyof typeof IndexQasResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexQasResponseData
 */
export interface IndexQasResponseData {
    /**
     * 
     * @type {Array<Qa>}
     * @memberof IndexQasResponseData
     */
    'qas': Array<Qa>;
    /**
     * 
     * @type {number}
     * @memberof IndexQasResponseData
     */
    'count': number;
}
/**
 * 美容レポテーマ一覧
 * @export
 * @interface IndexReportThemesRequest
 */
export interface IndexReportThemesRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexReportThemesRequest
     */
    'type': IndexReportThemesRequestTypeEnum;
}

export const IndexReportThemesRequestTypeEnum = {
    IndexReportThemes: 'IndexReportThemes'
} as const;

export type IndexReportThemesRequestTypeEnum = typeof IndexReportThemesRequestTypeEnum[keyof typeof IndexReportThemesRequestTypeEnum];

/**
 * 美容レポテーマ一覧
 * @export
 * @interface IndexReportThemesResponse
 */
export interface IndexReportThemesResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexReportThemesResponse
     */
    'type': IndexReportThemesResponseTypeEnum;
    /**
     * 
     * @type {IndexReportThemesResponseData}
     * @memberof IndexReportThemesResponse
     */
    'data': IndexReportThemesResponseData;
}

export const IndexReportThemesResponseTypeEnum = {
    IndexReportThemes: 'IndexReportThemes'
} as const;

export type IndexReportThemesResponseTypeEnum = typeof IndexReportThemesResponseTypeEnum[keyof typeof IndexReportThemesResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexReportThemesResponseData
 */
export interface IndexReportThemesResponseData {
    /**
     * 
     * @type {Array<ClinicTheme>}
     * @memberof IndexReportThemesResponseData
     */
    'themes': Array<ClinicTheme>;
}
/**
 * 美容レポ一覧
 * @export
 * @interface IndexReportsRequest
 */
export interface IndexReportsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexReportsRequest
     */
    'type': IndexReportsRequestTypeEnum;
    /**
     * 
     * @type {IndexReportsRequestData}
     * @memberof IndexReportsRequest
     */
    'data': IndexReportsRequestData;
}

export const IndexReportsRequestTypeEnum = {
    IndexReports: 'IndexReports'
} as const;

export type IndexReportsRequestTypeEnum = typeof IndexReportsRequestTypeEnum[keyof typeof IndexReportsRequestTypeEnum];

/**
 * 
 * @export
 * @interface IndexReportsRequestData
 */
export interface IndexReportsRequestData {
    /**
     * 
     * @type {Array<UserContentStatus>}
     * @memberof IndexReportsRequestData
     */
    'statuses'?: Array<UserContentStatus>;
    /**
     * 
     * @type {string}
     * @memberof IndexReportsRequestData
     */
    'applyDateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexReportsRequestData
     */
    'applyDateTill'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexReportsRequestData
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndexReportsRequestData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexReportsRequestData
     */
    'per'?: number;
}
/**
 * 美容レポ一覧
 * @export
 * @interface IndexReportsResponse
 */
export interface IndexReportsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexReportsResponse
     */
    'type': IndexReportsResponseTypeEnum;
    /**
     * 
     * @type {IndexReportsResponseData}
     * @memberof IndexReportsResponse
     */
    'data': IndexReportsResponseData;
}

export const IndexReportsResponseTypeEnum = {
    IndexReports: 'IndexReports'
} as const;

export type IndexReportsResponseTypeEnum = typeof IndexReportsResponseTypeEnum[keyof typeof IndexReportsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexReportsResponseData
 */
export interface IndexReportsResponseData {
    /**
     * 
     * @type {Array<Clinic>}
     * @memberof IndexReportsResponseData
     */
    'reports': Array<Clinic>;
    /**
     * 
     * @type {number}
     * @memberof IndexReportsResponseData
     */
    'count': number;
}
/**
 * 肌質一覧
 * @export
 * @interface IndexSkinsRequest
 */
export interface IndexSkinsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexSkinsRequest
     */
    'type': IndexSkinsRequestTypeEnum;
}

export const IndexSkinsRequestTypeEnum = {
    IndexSkins: 'IndexSkins'
} as const;

export type IndexSkinsRequestTypeEnum = typeof IndexSkinsRequestTypeEnum[keyof typeof IndexSkinsRequestTypeEnum];

/**
 * 肌質一覧
 * @export
 * @interface IndexSkinsResponse
 */
export interface IndexSkinsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexSkinsResponse
     */
    'type': IndexSkinsResponseTypeEnum;
    /**
     * 
     * @type {IndexSkinsResponseData}
     * @memberof IndexSkinsResponse
     */
    'data': IndexSkinsResponseData;
}

export const IndexSkinsResponseTypeEnum = {
    IndexSkins: 'IndexSkins'
} as const;

export type IndexSkinsResponseTypeEnum = typeof IndexSkinsResponseTypeEnum[keyof typeof IndexSkinsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexSkinsResponseData
 */
export interface IndexSkinsResponseData {
    /**
     * 
     * @type {Array<Skin>}
     * @memberof IndexSkinsResponseData
     */
    'skins': Array<Skin>;
}
/**
 * タグ一覧
 * @export
 * @interface IndexTagsRequest
 */
export interface IndexTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexTagsRequest
     */
    'type': IndexTagsRequestTypeEnum;
    /**
     * 
     * @type {IndexBrandsRequestData}
     * @memberof IndexTagsRequest
     */
    'data': IndexBrandsRequestData;
}

export const IndexTagsRequestTypeEnum = {
    IndexTags: 'IndexTags'
} as const;

export type IndexTagsRequestTypeEnum = typeof IndexTagsRequestTypeEnum[keyof typeof IndexTagsRequestTypeEnum];

/**
 * タグ一覧
 * @export
 * @interface IndexTagsResponse
 */
export interface IndexTagsResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexTagsResponse
     */
    'type': IndexTagsResponseTypeEnum;
    /**
     * 
     * @type {IndexTagsResponseData}
     * @memberof IndexTagsResponse
     */
    'data': IndexTagsResponseData;
}

export const IndexTagsResponseTypeEnum = {
    IndexTags: 'IndexTags'
} as const;

export type IndexTagsResponseTypeEnum = typeof IndexTagsResponseTypeEnum[keyof typeof IndexTagsResponseTypeEnum];

/**
 * 
 * @export
 * @interface IndexTagsResponseData
 */
export interface IndexTagsResponseData {
    /**
     * 
     * @type {Array<Tag>}
     * @memberof IndexTagsResponseData
     */
    'tags': Array<Tag>;
    /**
     * 
     * @type {number}
     * @memberof IndexTagsResponseData
     */
    'count': number;
}
/**
 * 画像挿入
 * @export
 * @interface InputImage
 */
export interface InputImage {
    /**
     * 
     * @type {string}
     * @memberof InputImage
     */
    'image': string;
}
/**
 * 
 * @export
 * @interface Interest
 */
export interface Interest {
    /**
     * 
     * @type {number}
     * @memberof Interest
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Interest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Kodawari
 */
export interface Kodawari {
    /**
     * 
     * @type {number}
     * @memberof Kodawari
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Kodawari
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Kodawari
     */
    'sortNo'?: string;
    /**
     * 
     * @type {Category}
     * @memberof Kodawari
     */
    'category': Category;
}
/**
 * 
 * @export
 * @interface KodawariOption
 */
export interface KodawariOption {
    /**
     * 
     * @type {number}
     * @memberof KodawariOption
     */
    'id': number;
    /**
     * 
     * @type {Kodawari}
     * @memberof KodawariOption
     */
    'kodawari': Kodawari;
    /**
     * 
     * @type {Product}
     * @memberof KodawariOption
     */
    'product': Product;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MailMagazineFlg = {
    NUMBER_1: 1,
    NUMBER_0: 0
} as const;

export type MailMagazineFlg = typeof MailMagazineFlg[keyof typeof MailMagazineFlg];


/**
 * 
 * @export
 * @interface MailMagazineHistory
 */
export interface MailMagazineHistory {
    /**
     * 
     * @type {number}
     * @memberof MailMagazineHistory
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MailMagazineHistory
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof MailMagazineHistory
     */
    'textBody': string;
    /**
     * 
     * @type {string}
     * @memberof MailMagazineHistory
     */
    'htmlBody': string;
}
/**
 * 
 * @export
 * @interface MailMagazineTemplate
 */
export interface MailMagazineTemplate {
    /**
     * 
     * @type {number}
     * @memberof MailMagazineTemplate
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MailMagazineTemplate
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof MailMagazineTemplate
     */
    'textBody': string;
    /**
     * 
     * @type {string}
     * @memberof MailMagazineTemplate
     */
    'htmlBody': string;
}
/**
 * 
 * @export
 * @interface Maker
 */
export interface Maker {
    /**
     * 
     * @type {number}
     * @memberof Maker
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Maker
     */
    'sortNo': number;
}
/**
 * 
 * @export
 * @interface Manager
 */
export interface Manager {
    /**
     * 
     * @type {number}
     * @memberof Manager
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Manager
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Manager
     */
    'authority': ManagerAuthorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Manager
     */
    'personalDataFlg': boolean;
}

export const ManagerAuthorityEnum = {
    Admin: 'ADMIN',
    Staff: 'STAFF',
    Guest: 'GUEST'
} as const;

export type ManagerAuthorityEnum = typeof ManagerAuthorityEnum[keyof typeof ManagerAuthorityEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ManagerAuthority = {
    Admin: 'ADMIN',
    Staff: 'STAFF',
    Guest: 'GUEST'
} as const;

export type ManagerAuthority = typeof ManagerAuthority[keyof typeof ManagerAuthority];


/**
 * 
 * @export
 * @enum {string}
 */

export const OfficialStatus = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type OfficialStatus = typeof OfficialStatus[keyof typeof OfficialStatus];


/**
 * 
 * @export
 * @interface Pref
 */
export interface Pref {
    /**
     * 
     * @type {number}
     * @memberof Pref
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Pref
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Pref
     */
    'sortNo'?: number;
}
/**
 * 
 * @export
 * @interface PresentCampaign
 */
export interface PresentCampaign {
    /**
     * 
     * @type {number}
     * @memberof PresentCampaign
     */
    'postId': number;
    /**
     * 
     * @type {string}
     * @memberof PresentCampaign
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PresentCampaign
     */
    'periodStart': string;
    /**
     * 
     * @type {string}
     * @memberof PresentCampaign
     */
    'periodEnd': string;
}
/**
 * 
 * @export
 * @interface PresentHistory
 */
export interface PresentHistory {
    /**
     * 
     * @type {number}
     * @memberof PresentHistory
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PresentHistory
     */
    'postId': number;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'present': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'periodS': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'periodE': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'postUrl': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'thumbUrl': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'name01': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'name02': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'kana01': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'kana02': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'addr01': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'addr02': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'contents': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'createDate': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'updateDate': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'customerBirth': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'customerSkins': string;
    /**
     * 
     * @type {string}
     * @memberof PresentHistory
     */
    'customerInterests': string;
    /**
     * 
     * @type {Pref}
     * @memberof PresentHistory
     */
    'pref': Pref;
    /**
     * 
     * @type {Customer}
     * @memberof PresentHistory
     */
    'customer': Customer;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name': string;
    /**
     * 
     * @type {ProductStatus}
     * @memberof Product
     */
    'productStatusId': ProductStatus;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'descriptionDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'productColors'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'productUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'productUrlTracking'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'brandUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'brandUrlTracking'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'priceText'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'priceUnit'?: string;
    /**
     * 基準価格 (dtb_product_classにあるもの）
     * @type {number}
     * @memberof Product
     */
    'price02': number;
    /**
     * AmazonURL
     * @type {string}
     * @memberof Product
     */
    'affiliate1'?: string;
    /**
     * YahooショッピングURL
     * @type {string}
     * @memberof Product
     */
    'affiliate2'?: string;
    /**
     * 楽天市場URL
     * @type {string}
     * @memberof Product
     */
    'affiliate3'?: string;
    /**
     * Qoo10 URL
     * @type {string}
     * @memberof Product
     */
    'affiliate4'?: string;
    /**
     * 
     * @type {Manager}
     * @memberof Product
     */
    'creator'?: Manager;
    /**
     * 
     * @type {Brand}
     * @memberof Product
     */
    'brand': Brand;
    /**
     * 
     * @type {Maker}
     * @memberof Product
     */
    'maker': Maker;
    /**
     * 
     * @type {Array<ProductCategory>}
     * @memberof Product
     */
    'productCategories'?: Array<ProductCategory>;
    /**
     * 
     * @type {Array<ProductTag>}
     * @memberof Product
     */
    'productTags'?: Array<ProductTag>;
    /**
     * 
     * @type {Array<KodawariOption>}
     * @memberof Product
     */
    'kodawariOptions'?: Array<KodawariOption>;
    /**
     * 
     * @type {Chanel}
     * @memberof Product
     */
    'chanel'?: Chanel;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'applyDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'releaseDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'createDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'updateDate'?: string;
    /**
     * 
     * @type {Array<ProductImage>}
     * @memberof Product
     */
    'productImages'?: Array<ProductImage>;
}
/**
 * 
 * @export
 * @interface ProductCategory
 */
export interface ProductCategory {
    /**
     * 
     * @type {number}
     * @memberof ProductCategory
     */
    'id': number;
    /**
     * 
     * @type {Category}
     * @memberof ProductCategory
     */
    'category': Category;
    /**
     * 
     * @type {Product}
     * @memberof ProductCategory
     */
    'product': Product;
}
/**
 * 
 * @export
 * @interface ProductImage
 */
export interface ProductImage {
    /**
     * 
     * @type {number}
     * @memberof ProductImage
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductImage
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductImage
     */
    'sortNo'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductImage
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ProductRecommend
 */
export interface ProductRecommend {
    /**
     * 
     * @type {number}
     * @memberof ProductRecommend
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductRecommend
     */
    'applyDate': string;
    /**
     * 
     * @type {Product}
     * @memberof ProductRecommend
     */
    'product': Product;
}
/**
 * 
 * @export
 * @interface ProductReview
 */
export interface ProductReview {
    /**
     * 
     * @type {number}
     * @memberof ProductReview
     */
    'id': number;
    /**
     * 
     * @type {UserContentStatus}
     * @memberof ProductReview
     */
    'statusId': UserContentStatus;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof ProductReview
     */
    'recommendLevel': number;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'reviewerName': string;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'image1Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'image2Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'image3Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'createDate': string;
    /**
     * 
     * @type {string}
     * @memberof ProductReview
     */
    'updateDate': string;
    /**
     * 
     * @type {Product}
     * @memberof ProductReview
     */
    'product': Product;
    /**
     * 
     * @type {Customer}
     * @memberof ProductReview
     */
    'customer': Customer;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProductStatus = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ProductStatus = typeof ProductStatus[keyof typeof ProductStatus];


/**
 * 
 * @export
 * @interface ProductTag
 */
export interface ProductTag {
    /**
     * 
     * @type {number}
     * @memberof ProductTag
     */
    'id': number;
    /**
     * 
     * @type {Tag}
     * @memberof ProductTag
     */
    'tag': Tag;
    /**
     * 
     * @type {Product}
     * @memberof ProductTag
     */
    'product': Product;
}
/**
 * 
 * @export
 * @interface Qa
 */
export interface Qa {
    /**
     * 
     * @type {number}
     * @memberof Qa
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Qa
     */
    'statusId': QaStatusIdEnum;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'nicname': string;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'image1'?: string;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'image2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'image3'?: string;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'createDate': string;
    /**
     * 
     * @type {string}
     * @memberof Qa
     */
    'updateDate': string;
    /**
     * 
     * @type {Array<QaAnswer>}
     * @memberof Qa
     */
    'answers'?: Array<QaAnswer>;
}

export const QaStatusIdEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_8: 8
} as const;

export type QaStatusIdEnum = typeof QaStatusIdEnum[keyof typeof QaStatusIdEnum];

/**
 * 
 * @export
 * @interface QaAnswer
 */
export interface QaAnswer {
    /**
     * 
     * @type {number}
     * @memberof QaAnswer
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof QaAnswer
     */
    'statusId': QaAnswerStatusIdEnum;
    /**
     * 
     * @type {string}
     * @memberof QaAnswer
     */
    'nicname': string;
    /**
     * 
     * @type {string}
     * @memberof QaAnswer
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof QaAnswer
     */
    'image1'?: string;
    /**
     * 
     * @type {string}
     * @memberof QaAnswer
     */
    'image2'?: string;
    /**
     * 
     * @type {string}
     * @memberof QaAnswer
     */
    'image3'?: string;
    /**
     * 
     * @type {string}
     * @memberof QaAnswer
     */
    'createDate': string;
    /**
     * 
     * @type {string}
     * @memberof QaAnswer
     */
    'updateDate': string;
}

export const QaAnswerStatusIdEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_8: 8
} as const;

export type QaAnswerStatusIdEnum = typeof QaAnswerStatusIdEnum[keyof typeof QaAnswerStatusIdEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const RecommendLevel = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type RecommendLevel = typeof RecommendLevel[keyof typeof RecommendLevel];


/**
 * 仮会員メール再送
 * @export
 * @interface ResendProvisionalRegistrationEmailCustomerResponse
 */
export interface ResendProvisionalRegistrationEmailCustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof ResendProvisionalRegistrationEmailCustomerResponse
     */
    'type': ResendProvisionalRegistrationEmailCustomerResponseTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ResendProvisionalRegistrationEmailCustomerResponse
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ResendProvisionalRegistrationEmailCustomerResponseTypeEnum = {
    ResendProvisionalRegistrationEmail: 'ResendProvisionalRegistrationEmail'
} as const;

export type ResendProvisionalRegistrationEmailCustomerResponseTypeEnum = typeof ResendProvisionalRegistrationEmailCustomerResponseTypeEnum[keyof typeof ResendProvisionalRegistrationEmailCustomerResponseTypeEnum];

/**
 * 
 * @export
 * @interface ResendProvisionalRegistrationEmailCustomerResponseData
 */
export interface ResendProvisionalRegistrationEmailCustomerResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResendProvisionalRegistrationEmailCustomerResponseData
     */
    'id': number;
}
/**
 * 仮会員メール再送
 * @export
 * @interface ResendProvisionalRegistrationEmailRequest
 */
export interface ResendProvisionalRegistrationEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendProvisionalRegistrationEmailRequest
     */
    'type': ResendProvisionalRegistrationEmailRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ResendProvisionalRegistrationEmailRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ResendProvisionalRegistrationEmailRequestTypeEnum = {
    ResendProvisionalRegistrationEmail: 'ResendProvisionalRegistrationEmail'
} as const;

export type ResendProvisionalRegistrationEmailRequestTypeEnum = typeof ResendProvisionalRegistrationEmailRequestTypeEnum[keyof typeof ResendProvisionalRegistrationEmailRequestTypeEnum];

/**
 * メールマガジン送信
 * @export
 * @interface SendMailMagazineRequest
 */
export interface SendMailMagazineRequest {
    /**
     * 
     * @type {string}
     * @memberof SendMailMagazineRequest
     */
    'type': SendMailMagazineRequestTypeEnum;
    /**
     * 
     * @type {SendMailMagazineRequestData}
     * @memberof SendMailMagazineRequest
     */
    'data': SendMailMagazineRequestData;
}

export const SendMailMagazineRequestTypeEnum = {
    SendMailMagazine: 'SendMailMagazine'
} as const;

export type SendMailMagazineRequestTypeEnum = typeof SendMailMagazineRequestTypeEnum[keyof typeof SendMailMagazineRequestTypeEnum];

/**
 * 
 * @export
 * @interface SendMailMagazineRequestData
 */
export interface SendMailMagazineRequestData {
    /**
     * 
     * @type {string}
     * @memberof SendMailMagazineRequestData
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof SendMailMagazineRequestData
     */
    'textBody': string;
    /**
     * 
     * @type {string}
     * @memberof SendMailMagazineRequestData
     */
    'htmlBody': string;
}
/**
 * メールマガジン送信
 * @export
 * @interface SendMailMagazineResponse
 */
export interface SendMailMagazineResponse {
    /**
     * 
     * @type {string}
     * @memberof SendMailMagazineResponse
     */
    'type': SendMailMagazineResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof SendMailMagazineResponse
     */
    'data': DestroyAdResponseData;
}

export const SendMailMagazineResponseTypeEnum = {
    SendMailMagazine: 'SendMailMagazine'
} as const;

export type SendMailMagazineResponseTypeEnum = typeof SendMailMagazineResponseTypeEnum[keyof typeof SendMailMagazineResponseTypeEnum];

/**
 * 広告詳細
 * @export
 * @interface ShowAdRequest
 */
export interface ShowAdRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowAdRequest
     */
    'type': ShowAdRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ShowAdRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ShowAdRequestTypeEnum = {
    ShowAd: 'ShowAd'
} as const;

export type ShowAdRequestTypeEnum = typeof ShowAdRequestTypeEnum[keyof typeof ShowAdRequestTypeEnum];

/**
 * 広告詳細
 * @export
 * @interface ShowAdResponse
 */
export interface ShowAdResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowAdResponse
     */
    'type': ShowAdResponseTypeEnum;
    /**
     * 
     * @type {ShowAdResponseData}
     * @memberof ShowAdResponse
     */
    'data': ShowAdResponseData;
}

export const ShowAdResponseTypeEnum = {
    ShowAd: 'ShowAd'
} as const;

export type ShowAdResponseTypeEnum = typeof ShowAdResponseTypeEnum[keyof typeof ShowAdResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowAdResponseData
 */
export interface ShowAdResponseData {
    /**
     * 
     * @type {Ad}
     * @memberof ShowAdResponseData
     */
    'ad': Ad;
}
/**
 * ブランド詳細
 * @export
 * @interface ShowBrandRequest
 */
export interface ShowBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowBrandRequest
     */
    'type': ShowBrandRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ShowBrandRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ShowBrandRequestTypeEnum = {
    ShowBrand: 'ShowBrand'
} as const;

export type ShowBrandRequestTypeEnum = typeof ShowBrandRequestTypeEnum[keyof typeof ShowBrandRequestTypeEnum];

/**
 * ブランド詳細
 * @export
 * @interface ShowBrandResponse
 */
export interface ShowBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowBrandResponse
     */
    'type': ShowBrandResponseTypeEnum;
    /**
     * 
     * @type {ShowBrandResponseData}
     * @memberof ShowBrandResponse
     */
    'data': ShowBrandResponseData;
}

export const ShowBrandResponseTypeEnum = {
    ShowBrand: 'ShowBrand'
} as const;

export type ShowBrandResponseTypeEnum = typeof ShowBrandResponseTypeEnum[keyof typeof ShowBrandResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowBrandResponseData
 */
export interface ShowBrandResponseData {
    /**
     * 
     * @type {Brand}
     * @memberof ShowBrandResponseData
     */
    'brand': Brand;
}
/**
 * 会員詳細
 * @export
 * @interface ShowCustomerRequest
 */
export interface ShowCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowCustomerRequest
     */
    'type': ShowCustomerRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ShowCustomerRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ShowCustomerRequestTypeEnum = {
    ShowCustomer: 'ShowCustomer'
} as const;

export type ShowCustomerRequestTypeEnum = typeof ShowCustomerRequestTypeEnum[keyof typeof ShowCustomerRequestTypeEnum];

/**
 * 会員詳細
 * @export
 * @interface ShowCustomerResponse
 */
export interface ShowCustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowCustomerResponse
     */
    'type': ShowCustomerResponseTypeEnum;
    /**
     * 
     * @type {ShowCustomerResponseData}
     * @memberof ShowCustomerResponse
     */
    'data': ShowCustomerResponseData;
}

export const ShowCustomerResponseTypeEnum = {
    ShowCustomer: 'ShowCustomer'
} as const;

export type ShowCustomerResponseTypeEnum = typeof ShowCustomerResponseTypeEnum[keyof typeof ShowCustomerResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowCustomerResponseData
 */
export interface ShowCustomerResponseData {
    /**
     * 
     * @type {Customer}
     * @memberof ShowCustomerResponseData
     */
    'customer': Customer;
}
/**
 * COSMEbi管理者詳細
 * @export
 * @interface ShowManagerRequest
 */
export interface ShowManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowManagerRequest
     */
    'type': ShowManagerRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ShowManagerRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ShowManagerRequestTypeEnum = {
    ShowManager: 'ShowManager'
} as const;

export type ShowManagerRequestTypeEnum = typeof ShowManagerRequestTypeEnum[keyof typeof ShowManagerRequestTypeEnum];

/**
 * COSMEbi管理者詳細
 * @export
 * @interface ShowManagerResponse
 */
export interface ShowManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowManagerResponse
     */
    'type': ShowManagerResponseTypeEnum;
    /**
     * 
     * @type {ShowManagerResponseData}
     * @memberof ShowManagerResponse
     */
    'data': ShowManagerResponseData;
}

export const ShowManagerResponseTypeEnum = {
    ShowManager: 'ShowManager'
} as const;

export type ShowManagerResponseTypeEnum = typeof ShowManagerResponseTypeEnum[keyof typeof ShowManagerResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowManagerResponseData
 */
export interface ShowManagerResponseData {
    /**
     * 
     * @type {Manager}
     * @memberof ShowManagerResponseData
     */
    'manager': Manager;
}
/**
 * 自分の情報取得
 * @export
 * @interface ShowMeRequest
 */
export interface ShowMeRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowMeRequest
     */
    'type': ShowMeRequestTypeEnum;
}

export const ShowMeRequestTypeEnum = {
    ShowMe: 'ShowMe'
} as const;

export type ShowMeRequestTypeEnum = typeof ShowMeRequestTypeEnum[keyof typeof ShowMeRequestTypeEnum];

/**
 * 自分の情報取得
 * @export
 * @interface ShowMeResponse
 */
export interface ShowMeResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowMeResponse
     */
    'type': ShowMeResponseTypeEnum;
    /**
     * 
     * @type {ShowManagerResponseData}
     * @memberof ShowMeResponse
     */
    'data': ShowManagerResponseData;
}

export const ShowMeResponseTypeEnum = {
    ShowMe: 'ShowMe'
} as const;

export type ShowMeResponseTypeEnum = typeof ShowMeResponseTypeEnum[keyof typeof ShowMeResponseTypeEnum];

/**
 * 商品詳細
 * @export
 * @interface ShowProductRequest
 */
export interface ShowProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowProductRequest
     */
    'type': ShowProductRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ShowProductRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ShowProductRequestTypeEnum = {
    ShowProduct: 'ShowProduct'
} as const;

export type ShowProductRequestTypeEnum = typeof ShowProductRequestTypeEnum[keyof typeof ShowProductRequestTypeEnum];

/**
 * 商品詳細
 * @export
 * @interface ShowProductResponse
 */
export interface ShowProductResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowProductResponse
     */
    'type': ShowProductResponseTypeEnum;
    /**
     * 
     * @type {ShowProductResponseData}
     * @memberof ShowProductResponse
     */
    'data': ShowProductResponseData;
}

export const ShowProductResponseTypeEnum = {
    ShowProduct: 'ShowProduct'
} as const;

export type ShowProductResponseTypeEnum = typeof ShowProductResponseTypeEnum[keyof typeof ShowProductResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowProductResponseData
 */
export interface ShowProductResponseData {
    /**
     * 
     * @type {Product}
     * @memberof ShowProductResponseData
     */
    'product': Product;
}
/**
 * クチコミ詳細
 * @export
 * @interface ShowProductReviewRequest
 */
export interface ShowProductReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowProductReviewRequest
     */
    'type': ShowProductReviewRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ShowProductReviewRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ShowProductReviewRequestTypeEnum = {
    ShowProductReview: 'ShowProductReview'
} as const;

export type ShowProductReviewRequestTypeEnum = typeof ShowProductReviewRequestTypeEnum[keyof typeof ShowProductReviewRequestTypeEnum];

/**
 * クチコミ詳細
 * @export
 * @interface ShowProductReviewResponse
 */
export interface ShowProductReviewResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowProductReviewResponse
     */
    'type': ShowProductReviewResponseTypeEnum;
    /**
     * 
     * @type {ShowProductReviewResponseData}
     * @memberof ShowProductReviewResponse
     */
    'data': ShowProductReviewResponseData;
}

export const ShowProductReviewResponseTypeEnum = {
    ShowProductReview: 'ShowProductReview'
} as const;

export type ShowProductReviewResponseTypeEnum = typeof ShowProductReviewResponseTypeEnum[keyof typeof ShowProductReviewResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowProductReviewResponseData
 */
export interface ShowProductReviewResponseData {
    /**
     * 
     * @type {ProductReview}
     * @memberof ShowProductReviewResponseData
     */
    'productReview': ProductReview;
}
/**
 * Q&A回答詳細
 * @export
 * @interface ShowQaAnswerRequest
 */
export interface ShowQaAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowQaAnswerRequest
     */
    'type': ShowQaAnswerRequestTypeEnum;
    /**
     * 
     * @type {ShowQaRequestData}
     * @memberof ShowQaAnswerRequest
     */
    'data': ShowQaRequestData;
}

export const ShowQaAnswerRequestTypeEnum = {
    ShowQaAnswer: 'ShowQaAnswer'
} as const;

export type ShowQaAnswerRequestTypeEnum = typeof ShowQaAnswerRequestTypeEnum[keyof typeof ShowQaAnswerRequestTypeEnum];

/**
 * Q&A回答詳細
 * @export
 * @interface ShowQaAnswerResponse
 */
export interface ShowQaAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowQaAnswerResponse
     */
    'type': ShowQaAnswerResponseTypeEnum;
    /**
     * 
     * @type {ShowQaAnswerResponseData}
     * @memberof ShowQaAnswerResponse
     */
    'data': ShowQaAnswerResponseData;
}

export const ShowQaAnswerResponseTypeEnum = {
    ShowQaAnswer: 'ShowQaAnswer'
} as const;

export type ShowQaAnswerResponseTypeEnum = typeof ShowQaAnswerResponseTypeEnum[keyof typeof ShowQaAnswerResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowQaAnswerResponseData
 */
export interface ShowQaAnswerResponseData {
    /**
     * 
     * @type {QaAnswer}
     * @memberof ShowQaAnswerResponseData
     */
    'qaAnswer': QaAnswer;
}
/**
 * Q&A詳細
 * @export
 * @interface ShowQaRequest
 */
export interface ShowQaRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowQaRequest
     */
    'type': ShowQaRequestTypeEnum;
    /**
     * 
     * @type {ShowQaRequestData}
     * @memberof ShowQaRequest
     */
    'data': ShowQaRequestData;
}

export const ShowQaRequestTypeEnum = {
    ShowQa: 'ShowQa'
} as const;

export type ShowQaRequestTypeEnum = typeof ShowQaRequestTypeEnum[keyof typeof ShowQaRequestTypeEnum];

/**
 * 
 * @export
 * @interface ShowQaRequestData
 */
export interface ShowQaRequestData {
    /**
     * 
     * @type {number}
     * @memberof ShowQaRequestData
     */
    'id'?: number;
}
/**
 * Q&A詳細
 * @export
 * @interface ShowQaResponse
 */
export interface ShowQaResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowQaResponse
     */
    'type': ShowQaResponseTypeEnum;
    /**
     * 
     * @type {ShowQaResponseData}
     * @memberof ShowQaResponse
     */
    'data': ShowQaResponseData;
}

export const ShowQaResponseTypeEnum = {
    ShowQa: 'ShowQa'
} as const;

export type ShowQaResponseTypeEnum = typeof ShowQaResponseTypeEnum[keyof typeof ShowQaResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowQaResponseData
 */
export interface ShowQaResponseData {
    /**
     * 
     * @type {Qa}
     * @memberof ShowQaResponseData
     */
    'qa': Qa;
}
/**
 * 美容レポ詳細
 * @export
 * @interface ShowReportRequest
 */
export interface ShowReportRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowReportRequest
     */
    'type': ShowReportRequestTypeEnum;
    /**
     * 
     * @type {ResendProvisionalRegistrationEmailCustomerResponseData}
     * @memberof ShowReportRequest
     */
    'data': ResendProvisionalRegistrationEmailCustomerResponseData;
}

export const ShowReportRequestTypeEnum = {
    ShowReport: 'ShowReport'
} as const;

export type ShowReportRequestTypeEnum = typeof ShowReportRequestTypeEnum[keyof typeof ShowReportRequestTypeEnum];

/**
 * 美容レポ詳細
 * @export
 * @interface ShowReportResponse
 */
export interface ShowReportResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowReportResponse
     */
    'type': ShowReportResponseTypeEnum;
    /**
     * 
     * @type {ShowReportResponseData}
     * @memberof ShowReportResponse
     */
    'data': ShowReportResponseData;
}

export const ShowReportResponseTypeEnum = {
    ShowReport: 'ShowReport'
} as const;

export type ShowReportResponseTypeEnum = typeof ShowReportResponseTypeEnum[keyof typeof ShowReportResponseTypeEnum];

/**
 * 
 * @export
 * @interface ShowReportResponseData
 */
export interface ShowReportResponseData {
    /**
     * 
     * @type {Clinic}
     * @memberof ShowReportResponseData
     */
    'report': Clinic;
}
/**
 * 
 * @export
 * @interface Skin
 */
export interface Skin {
    /**
     * 
     * @type {number}
     * @memberof Skin
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Skin
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * 
     * @type {number}
     * @memberof Tag
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Tag
     */
    'sortNo'?: number;
}
/**
 * 広告更新
 * @export
 * @interface UpdateAdRequest
 */
export interface UpdateAdRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdRequest
     */
    'type': UpdateAdRequestTypeEnum;
    /**
     * 
     * @type {UpdateAdRequestData}
     * @memberof UpdateAdRequest
     */
    'data': UpdateAdRequestData;
}

export const UpdateAdRequestTypeEnum = {
    UpdateAd: 'UpdateAd'
} as const;

export type UpdateAdRequestTypeEnum = typeof UpdateAdRequestTypeEnum[keyof typeof UpdateAdRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateAdRequestData
 */
export interface UpdateAdRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateAdRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdRequestData
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAdRequestData
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {AdType}
     * @memberof UpdateAdRequestData
     */
    'adType'?: AdType;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdRequestData
     */
    'pcImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdRequestData
     */
    'spImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdRequestData
     */
    'linkUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdRequestData
     */
    'publishFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdRequestData
     */
    'publishTill'?: string;
}
/**
 * 広告更新
 * @export
 * @interface UpdateAdResponse
 */
export interface UpdateAdResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponse
     */
    'type': UpdateAdResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateAdResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateAdResponseTypeEnum = {
    UpdateAd: 'UpdateAd'
} as const;

export type UpdateAdResponseTypeEnum = typeof UpdateAdResponseTypeEnum[keyof typeof UpdateAdResponseTypeEnum];

/**
 * ブランド更新
 * @export
 * @interface UpdateBrandRequest
 */
export interface UpdateBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'type': UpdateBrandRequestTypeEnum;
    /**
     * 
     * @type {UpdateBrandRequestData}
     * @memberof UpdateBrandRequest
     */
    'data': UpdateBrandRequestData;
}

export const UpdateBrandRequestTypeEnum = {
    UpdateBrand: 'UpdateBrand'
} as const;

export type UpdateBrandRequestTypeEnum = typeof UpdateBrandRequestTypeEnum[keyof typeof UpdateBrandRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateBrandRequestData
 */
export interface UpdateBrandRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequestData
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequestData
     */
    'subName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequestData
     */
    'akasatana'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequestData
     */
    'channel'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequestData
     */
    'searchWord'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequestData
     */
    'purchaseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequestData
     */
    'topPageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBrandRequestData
     */
    'isPublished'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequestData
     */
    'makerId'?: number;
}
/**
 * ブランド更新
 * @export
 * @interface UpdateBrandResponse
 */
export interface UpdateBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandResponse
     */
    'type': UpdateBrandResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateBrandResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateBrandResponseTypeEnum = {
    UpdateBrand: 'UpdateBrand'
} as const;

export type UpdateBrandResponseTypeEnum = typeof UpdateBrandResponseTypeEnum[keyof typeof UpdateBrandResponseTypeEnum];

/**
 * カテゴリー更新
 * @export
 * @interface UpdateCategoryRequest
 */
export interface UpdateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryRequest
     */
    'type': UpdateCategoryRequestTypeEnum;
    /**
     * 
     * @type {UpdateCategoryRequestData}
     * @memberof UpdateCategoryRequest
     */
    'data': UpdateCategoryRequestData;
}

export const UpdateCategoryRequestTypeEnum = {
    UpdateCategory: 'UpdateCategory'
} as const;

export type UpdateCategoryRequestTypeEnum = typeof UpdateCategoryRequestTypeEnum[keyof typeof UpdateCategoryRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateCategoryRequestData
 */
export interface UpdateCategoryRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateCategoryRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryRequestData
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCategoryRequestData
     */
    'sortNo'?: number;
}
/**
 * カテゴリー更新
 * @export
 * @interface UpdateCategoryResponse
 */
export interface UpdateCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryResponse
     */
    'type': UpdateCategoryResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateCategoryResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateCategoryResponseTypeEnum = {
    UpdateCategory: 'UpdateCategory'
} as const;

export type UpdateCategoryResponseTypeEnum = typeof UpdateCategoryResponseTypeEnum[keyof typeof UpdateCategoryResponseTypeEnum];

/**
 * 会員更新
 * @export
 * @interface UpdateCustomerRequest
 */
export interface UpdateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'type': UpdateCustomerRequestTypeEnum;
    /**
     * 
     * @type {UpdateCustomerRequestData}
     * @memberof UpdateCustomerRequest
     */
    'data': UpdateCustomerRequestData;
}

export const UpdateCustomerRequestTypeEnum = {
    UpdateCustomer: 'UpdateCustomer'
} as const;

export type UpdateCustomerRequestTypeEnum = typeof UpdateCustomerRequestTypeEnum[keyof typeof UpdateCustomerRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateCustomerRequestData
 */
export interface UpdateCustomerRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'email'?: string;
    /**
     * 
     * @type {CustomerStatus}
     * @memberof UpdateCustomerRequestData
     */
    'customerStatusId'?: CustomerStatus;
    /**
     * 
     * @type {OfficialStatus}
     * @memberof UpdateCustomerRequestData
     */
    'officialStatusId'?: OfficialStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'name01'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'name02'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'kana01'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'kana02'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'addr01'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'addr02'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'birth'?: string;
    /**
     * 
     * @type {MailMagazineFlg}
     * @memberof UpdateCustomerRequestData
     */
    'plgMailmagazineFlg'?: MailMagazineFlg;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'nicname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'facebook'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'instagtam'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequestData
     */
    'blog'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateCustomerRequestData
     */
    'interestIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateCustomerRequestData
     */
    'skinIds'?: Array<number>;
}
/**
 * 会員更新
 * @export
 * @interface UpdateCustomerResponse
 */
export interface UpdateCustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerResponse
     */
    'type': UpdateCustomerResponseTypeEnum;
    /**
     * 
     * @type {CreateCustomerResponseData}
     * @memberof UpdateCustomerResponse
     */
    'data': CreateCustomerResponseData;
}

export const UpdateCustomerResponseTypeEnum = {
    UpdateCustomer: 'UpdateCustomer'
} as const;

export type UpdateCustomerResponseTypeEnum = typeof UpdateCustomerResponseTypeEnum[keyof typeof UpdateCustomerResponseTypeEnum];

/**
 * 全体通知更新
 * @export
 * @interface UpdateGlobalNotificationRequest
 */
export interface UpdateGlobalNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGlobalNotificationRequest
     */
    'type': UpdateGlobalNotificationRequestTypeEnum;
    /**
     * 
     * @type {UpdateGlobalNotificationRequestData}
     * @memberof UpdateGlobalNotificationRequest
     */
    'data': UpdateGlobalNotificationRequestData;
}

export const UpdateGlobalNotificationRequestTypeEnum = {
    UpdateGlobalNotification: 'UpdateGlobalNotification'
} as const;

export type UpdateGlobalNotificationRequestTypeEnum = typeof UpdateGlobalNotificationRequestTypeEnum[keyof typeof UpdateGlobalNotificationRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateGlobalNotificationRequestData
 */
export interface UpdateGlobalNotificationRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateGlobalNotificationRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateGlobalNotificationRequestData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGlobalNotificationRequestData
     */
    'linkType'?: UpdateGlobalNotificationRequestDataLinkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateGlobalNotificationRequestData
     */
    'linkValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGlobalNotificationRequestData
     */
    'notifiedAt': string;
}

export const UpdateGlobalNotificationRequestDataLinkTypeEnum = {
    Info: 'info'
} as const;

export type UpdateGlobalNotificationRequestDataLinkTypeEnum = typeof UpdateGlobalNotificationRequestDataLinkTypeEnum[keyof typeof UpdateGlobalNotificationRequestDataLinkTypeEnum];

/**
 * 全体通知更新
 * @export
 * @interface UpdateGlobalNotificationResponse
 */
export interface UpdateGlobalNotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateGlobalNotificationResponse
     */
    'type': UpdateGlobalNotificationResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateGlobalNotificationResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateGlobalNotificationResponseTypeEnum = {
    UpdateGlobalNotification: 'UpdateGlobalNotification'
} as const;

export type UpdateGlobalNotificationResponseTypeEnum = typeof UpdateGlobalNotificationResponseTypeEnum[keyof typeof UpdateGlobalNotificationResponseTypeEnum];

/**
 * メールマガジンテンプレート更新
 * @export
 * @interface UpdateMagazineTemplateRequest
 */
export interface UpdateMagazineTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMagazineTemplateRequest
     */
    'type': UpdateMagazineTemplateRequestTypeEnum;
    /**
     * 
     * @type {UpdateMagazineTemplateRequestData}
     * @memberof UpdateMagazineTemplateRequest
     */
    'data': UpdateMagazineTemplateRequestData;
}

export const UpdateMagazineTemplateRequestTypeEnum = {
    UpdateMagazineTemplate: 'UpdateMagazineTemplate'
} as const;

export type UpdateMagazineTemplateRequestTypeEnum = typeof UpdateMagazineTemplateRequestTypeEnum[keyof typeof UpdateMagazineTemplateRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateMagazineTemplateRequestData
 */
export interface UpdateMagazineTemplateRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateMagazineTemplateRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateMagazineTemplateRequestData
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMagazineTemplateRequestData
     */
    'textBody'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMagazineTemplateRequestData
     */
    'htmlBody'?: string;
}
/**
 * メールマガジンテンプレート更新
 * @export
 * @interface UpdateMagazineTemplateResponse
 */
export interface UpdateMagazineTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateMagazineTemplateResponse
     */
    'type': UpdateMagazineTemplateResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateMagazineTemplateResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateMagazineTemplateResponseTypeEnum = {
    UpdateMagazineTemplate: 'UpdateMagazineTemplate'
} as const;

export type UpdateMagazineTemplateResponseTypeEnum = typeof UpdateMagazineTemplateResponseTypeEnum[keyof typeof UpdateMagazineTemplateResponseTypeEnum];

/**
 * メーカー更新
 * @export
 * @interface UpdateMakerRequest
 */
export interface UpdateMakerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMakerRequest
     */
    'type': UpdateMakerRequestTypeEnum;
    /**
     * 
     * @type {UpdateMakerRequestData}
     * @memberof UpdateMakerRequest
     */
    'data': UpdateMakerRequestData;
}

export const UpdateMakerRequestTypeEnum = {
    UpdateMaker: 'UpdateMaker'
} as const;

export type UpdateMakerRequestTypeEnum = typeof UpdateMakerRequestTypeEnum[keyof typeof UpdateMakerRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateMakerRequestData
 */
export interface UpdateMakerRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateMakerRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateMakerRequestData
     */
    'name': string;
}
/**
 * メーカー更新
 * @export
 * @interface UpdateMakerResponse
 */
export interface UpdateMakerResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateMakerResponse
     */
    'type': UpdateMakerResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof UpdateMakerResponse
     */
    'data': DestroyAdResponseData;
}

export const UpdateMakerResponseTypeEnum = {
    UpdateMaker: 'UpdateMaker'
} as const;

export type UpdateMakerResponseTypeEnum = typeof UpdateMakerResponseTypeEnum[keyof typeof UpdateMakerResponseTypeEnum];

/**
 * COSMEbi管理者更新
 * @export
 * @interface UpdateManagerRequest
 */
export interface UpdateManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateManagerRequest
     */
    'type': UpdateManagerRequestTypeEnum;
    /**
     * 
     * @type {UpdateManagerRequestData}
     * @memberof UpdateManagerRequest
     */
    'data': UpdateManagerRequestData;
}

export const UpdateManagerRequestTypeEnum = {
    UpdateManager: 'UpdateManager'
} as const;

export type UpdateManagerRequestTypeEnum = typeof UpdateManagerRequestTypeEnum[keyof typeof UpdateManagerRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateManagerRequestData
 */
export interface UpdateManagerRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateManagerRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateManagerRequestData
     */
    'email'?: string;
    /**
     * 
     * @type {ManagerAuthority}
     * @memberof UpdateManagerRequestData
     */
    'authority'?: ManagerAuthority;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateManagerRequestData
     */
    'personalDataFlg'?: boolean;
}
/**
 * COSMEbi管理者更新
 * @export
 * @interface UpdateManagerResponse
 */
export interface UpdateManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateManagerResponse
     */
    'type': UpdateManagerResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateManagerResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateManagerResponseTypeEnum = {
    UpdateManager: 'UpdateManager'
} as const;

export type UpdateManagerResponseTypeEnum = typeof UpdateManagerResponseTypeEnum[keyof typeof UpdateManagerResponseTypeEnum];

/**
 * おすすめ商品更新
 * @export
 * @interface UpdateProductRecommendRequest
 */
export interface UpdateProductRecommendRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRecommendRequest
     */
    'type': UpdateProductRecommendRequestTypeEnum;
    /**
     * 
     * @type {UpdateProductRecommendRequestData}
     * @memberof UpdateProductRecommendRequest
     */
    'data': UpdateProductRecommendRequestData;
}

export const UpdateProductRecommendRequestTypeEnum = {
    UpdateProductRecommend: 'UpdateProductRecommend'
} as const;

export type UpdateProductRecommendRequestTypeEnum = typeof UpdateProductRecommendRequestTypeEnum[keyof typeof UpdateProductRecommendRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateProductRecommendRequestData
 */
export interface UpdateProductRecommendRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRecommendRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRecommendRequestData
     */
    'applyDate': string;
}
/**
 * おすすめ商品更新
 * @export
 * @interface UpdateProductRecommendResponse
 */
export interface UpdateProductRecommendResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRecommendResponse
     */
    'type': UpdateProductRecommendResponseTypeEnum;
    /**
     * 
     * @type {DestroyAdResponseData}
     * @memberof UpdateProductRecommendResponse
     */
    'data': DestroyAdResponseData;
}

export const UpdateProductRecommendResponseTypeEnum = {
    DestroyProductRecommend: 'DestroyProductRecommend'
} as const;

export type UpdateProductRecommendResponseTypeEnum = typeof UpdateProductRecommendResponseTypeEnum[keyof typeof UpdateProductRecommendResponseTypeEnum];

/**
 * 商品更新
 * @export
 * @interface UpdateProductRequest
 */
export interface UpdateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'type': UpdateProductRequestTypeEnum;
    /**
     * 
     * @type {UpdateProductRequestData}
     * @memberof UpdateProductRequest
     */
    'data': UpdateProductRequestData;
}

export const UpdateProductRequestTypeEnum = {
    UpdateProduct: 'UpdateProduct'
} as const;

export type UpdateProductRequestTypeEnum = typeof UpdateProductRequestTypeEnum[keyof typeof UpdateProductRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateProductRequestData
 */
export interface UpdateProductRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequestData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'name': string;
    /**
     * 
     * @type {ProductStatus}
     * @memberof UpdateProductRequestData
     */
    'productStatusId'?: ProductStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'descriptionDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'productUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'productUrlTracking'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'brandUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'brandUrlTracking'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'priceText'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'priceUnit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequestData
     */
    'price02'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequestData
     */
    'brandId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'affiliate1'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'affiliate2'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'affiliate3'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequestData
     */
    'affiliate4'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateProductRequestData
     */
    'categoryIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateProductRequestData
     */
    'tagIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateProductRequestData
     */
    'kodawariIds'?: Array<number>;
    /**
     * 
     * @type {Array<ProductImage | InputImage>}
     * @memberof UpdateProductRequestData
     */
    'productImages'?: Array<ProductImage | InputImage>;
}
/**
 * 商品更新
 * @export
 * @interface UpdateProductResponse
 */
export interface UpdateProductResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductResponse
     */
    'type': UpdateProductResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateProductResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateProductResponseTypeEnum = {
    UpdateProduct: 'UpdateProduct'
} as const;

export type UpdateProductResponseTypeEnum = typeof UpdateProductResponseTypeEnum[keyof typeof UpdateProductResponseTypeEnum];

/**
 * クチコミ更新
 * @export
 * @interface UpdateProductReviewRequest
 */
export interface UpdateProductReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewRequest
     */
    'type': UpdateProductReviewRequestTypeEnum;
    /**
     * 
     * @type {UpdateProductReviewRequestData}
     * @memberof UpdateProductReviewRequest
     */
    'data': UpdateProductReviewRequestData;
}

export const UpdateProductReviewRequestTypeEnum = {
    UpdateProductReview: 'UpdateProductReview'
} as const;

export type UpdateProductReviewRequestTypeEnum = typeof UpdateProductReviewRequestTypeEnum[keyof typeof UpdateProductReviewRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateProductReviewRequestData
 */
export interface UpdateProductReviewRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateProductReviewRequestData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductReviewRequestData
     */
    'statusId'?: UpdateProductReviewRequestDataStatusIdEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewRequestData
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewRequestData
     */
    'comment'?: string;
    /**
     * 
     * @type {RecommendLevel}
     * @memberof UpdateProductReviewRequestData
     */
    'recommendLevel'?: RecommendLevel;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewRequestData
     */
    'reviewerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewRequestData
     */
    'image1'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewRequestData
     */
    'image2'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewRequestData
     */
    'image3'?: string;
}

export const UpdateProductReviewRequestDataStatusIdEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_8: 8
} as const;

export type UpdateProductReviewRequestDataStatusIdEnum = typeof UpdateProductReviewRequestDataStatusIdEnum[keyof typeof UpdateProductReviewRequestDataStatusIdEnum];

/**
 * クチコミ更新
 * @export
 * @interface UpdateProductReviewResponse
 */
export interface UpdateProductReviewResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductReviewResponse
     */
    'type': UpdateProductReviewResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateProductReviewResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateProductReviewResponseTypeEnum = {
    UpdateProductReview: 'UpdateProductReview'
} as const;

export type UpdateProductReviewResponseTypeEnum = typeof UpdateProductReviewResponseTypeEnum[keyof typeof UpdateProductReviewResponseTypeEnum];

/**
 * Q&A回答更新
 * @export
 * @interface UpdateQaAnswerRequest
 */
export interface UpdateQaAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateQaAnswerRequest
     */
    'type': UpdateQaAnswerRequestTypeEnum;
    /**
     * 
     * @type {UpdateQaAnswerRequestData}
     * @memberof UpdateQaAnswerRequest
     */
    'data': UpdateQaAnswerRequestData;
}

export const UpdateQaAnswerRequestTypeEnum = {
    UpdateQaAnswer: 'UpdateQaAnswer'
} as const;

export type UpdateQaAnswerRequestTypeEnum = typeof UpdateQaAnswerRequestTypeEnum[keyof typeof UpdateQaAnswerRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateQaAnswerRequestData
 */
export interface UpdateQaAnswerRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateQaAnswerRequestData
     */
    'id': number;
    /**
     * 
     * @type {UserContentStatus}
     * @memberof UpdateQaAnswerRequestData
     */
    'statusId'?: UserContentStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateQaAnswerRequestData
     */
    'nicname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateQaAnswerRequestData
     */
    'comment'?: string;
}
/**
 * Q&A回答更新
 * @export
 * @interface UpdateQaAnswerResponse
 */
export interface UpdateQaAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateQaAnswerResponse
     */
    'type': UpdateQaAnswerResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateQaAnswerResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateQaAnswerResponseTypeEnum = {
    UpdateQaAnswer: 'UpdateQaAnswer'
} as const;

export type UpdateQaAnswerResponseTypeEnum = typeof UpdateQaAnswerResponseTypeEnum[keyof typeof UpdateQaAnswerResponseTypeEnum];

/**
 * Q&A更新
 * @export
 * @interface UpdateQaRequest
 */
export interface UpdateQaRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateQaRequest
     */
    'type': UpdateQaRequestTypeEnum;
    /**
     * 
     * @type {UpdateQaRequestData}
     * @memberof UpdateQaRequest
     */
    'data': UpdateQaRequestData;
}

export const UpdateQaRequestTypeEnum = {
    UpdateQa: 'UpdateQa'
} as const;

export type UpdateQaRequestTypeEnum = typeof UpdateQaRequestTypeEnum[keyof typeof UpdateQaRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateQaRequestData
 */
export interface UpdateQaRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateQaRequestData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateQaRequestData
     */
    'statusId'?: UpdateQaRequestDataStatusIdEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateQaRequestData
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateQaRequestData
     */
    'nicname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateQaRequestData
     */
    'comment'?: string;
}

export const UpdateQaRequestDataStatusIdEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_8: 8
} as const;

export type UpdateQaRequestDataStatusIdEnum = typeof UpdateQaRequestDataStatusIdEnum[keyof typeof UpdateQaRequestDataStatusIdEnum];

/**
 * Q&A更新
 * @export
 * @interface UpdateQaResponse
 */
export interface UpdateQaResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateQaResponse
     */
    'type': UpdateQaResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateQaResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateQaResponseTypeEnum = {
    UpdateQa: 'UpdateQa'
} as const;

export type UpdateQaResponseTypeEnum = typeof UpdateQaResponseTypeEnum[keyof typeof UpdateQaResponseTypeEnum];

/**
 * 美容レポ更新
 * @export
 * @interface UpdateReportRequest
 */
export interface UpdateReportRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequest
     */
    'type': UpdateReportRequestTypeEnum;
    /**
     * 
     * @type {UpdateReportRequestData}
     * @memberof UpdateReportRequest
     */
    'data': UpdateReportRequestData;
}

export const UpdateReportRequestTypeEnum = {
    UpdateReport: 'UpdateReport'
} as const;

export type UpdateReportRequestTypeEnum = typeof UpdateReportRequestTypeEnum[keyof typeof UpdateReportRequestTypeEnum];

/**
 * 
 * @export
 * @interface UpdateReportRequestData
 */
export interface UpdateReportRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'id': number;
    /**
     * 
     * @type {UserContentStatus}
     * @memberof UpdateReportRequestData
     */
    'statusId'?: UserContentStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'nicname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'image1'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'image2'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'image3'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'image4'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'image5'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product1'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product2'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product3'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product4'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product5'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product6'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product7'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'product8'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportRequestData
     */
    'applyDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportRequestData
     */
    'themeId'?: number;
}
/**
 * 美容レポ更新
 * @export
 * @interface UpdateReportResponse
 */
export interface UpdateReportResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateReportResponse
     */
    'type': UpdateReportResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateReportResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateReportResponseTypeEnum = {
    UpdateReport: 'UpdateReport'
} as const;

export type UpdateReportResponseTypeEnum = typeof UpdateReportResponseTypeEnum[keyof typeof UpdateReportResponseTypeEnum];

/**
 * タグ更新
 * @export
 * @interface UpdateTagRequest
 */
export interface UpdateTagRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTagRequest
     */
    'type': UpdateTagRequestTypeEnum;
    /**
     * 
     * @type {UpdateMakerRequestData}
     * @memberof UpdateTagRequest
     */
    'data': UpdateMakerRequestData;
}

export const UpdateTagRequestTypeEnum = {
    UpdateTag: 'UpdateTag'
} as const;

export type UpdateTagRequestTypeEnum = typeof UpdateTagRequestTypeEnum[keyof typeof UpdateTagRequestTypeEnum];

/**
 * タグ更新
 * @export
 * @interface UpdateTagResponse
 */
export interface UpdateTagResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateTagResponse
     */
    'type': UpdateTagResponseTypeEnum;
    /**
     * 
     * @type {CreateAdResponseData}
     * @memberof UpdateTagResponse
     */
    'data': CreateAdResponseData;
}

export const UpdateTagResponseTypeEnum = {
    UpdateTag: 'UpdateTag'
} as const;

export type UpdateTagResponseTypeEnum = typeof UpdateTagResponseTypeEnum[keyof typeof UpdateTagResponseTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const UserContentStatus = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_8: 8
} as const;

export type UserContentStatus = typeof UserContentStatus[keyof typeof UserContentStatus];



/**
 * AuthorizedRequestApi - axios parameter creator
 * @export
 */
export const AuthorizedRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 認証が必要なAPI
         * @param {AuthorizedRequest} [authorizedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedRequest: async (authorizedRequest?: AuthorizedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authorized-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizedRequestApi - functional programming interface
 * @export
 */
export const AuthorizedRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizedRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 認証が必要なAPI
         * @param {AuthorizedRequest} [authorizedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizedRequest(authorizedRequest?: AuthorizedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizedRequest(authorizedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthorizedRequestApi - factory interface
 * @export
 */
export const AuthorizedRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizedRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary 認証が必要なAPI
         * @param {AuthorizedRequest} [authorizedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedRequest(authorizedRequest?: AuthorizedRequest, options?: any): AxiosPromise<AuthorizedResponse> {
            return localVarFp.authorizedRequest(authorizedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorizedRequestApi - object-oriented interface
 * @export
 * @class AuthorizedRequestApi
 * @extends {BaseAPI}
 */
export class AuthorizedRequestApi extends BaseAPI {
    /**
     * 
     * @summary 認証が必要なAPI
     * @param {AuthorizedRequest} [authorizedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizedRequestApi
     */
    public authorizedRequest(authorizedRequest?: AuthorizedRequest, options?: AxiosRequestConfig) {
        return AuthorizedRequestApiFp(this.configuration).authorizedRequest(authorizedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


